webpackJsonp([4],{

/***/ 1533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemFarmerTickets_vue__ = __webpack_require__(1885);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3ddfe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemFarmerTickets_vue__ = __webpack_require__(2309);
function injectStyle (ssrContext) {
  __webpack_require__(2285)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemFarmerTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3ddfe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemFarmerTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1562);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDate */
/* harmony export (immutable) */ __webpack_exports__["d"] = toDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidDate;
/* unused harmony export startOfWeek */
/* harmony export (immutable) */ __webpack_exports__["c"] = startOfWeekYear;
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeek;
function isDate(value) {
  return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
}
function toDate(value) {
  if (isDate(value)) {
    return new Date(value.getTime());
  }

  if (value == null) {
    return new Date(NaN);
  }

  return new Date(value);
}
function isValidDate(value) {
  return isDate(value) && !isNaN(value.getTime());
}
function startOfWeek(value) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!(firstDayOfWeek >= 0 && firstDayOfWeek <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }

  var date = toDate(value);
  var day = date.getDay();
  var diff = (day + 7 - firstDayOfWeek) % 7;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfWeekYear(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      _ref$firstWeekContain = _ref.firstWeekContainsDate,
      firstWeekContainsDate = _ref$firstWeekContain === void 0 ? 1 : _ref$firstWeekContain;

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7');
  }

  var date = toDate(value);
  var year = date.getFullYear();
  var firstDateOfFirstWeek = new Date(0);

  for (var i = year + 1; i >= year - 1; i--) {
    firstDateOfFirstWeek.setFullYear(i, 0, firstWeekContainsDate);
    firstDateOfFirstWeek.setHours(0, 0, 0, 0);
    firstDateOfFirstWeek = startOfWeek(firstDateOfFirstWeek, firstDayOfWeek);

    if (date.getTime() >= firstDateOfFirstWeek.getTime()) {
      break;
    }
  }

  return firstDateOfFirstWeek;
}
function getWeek(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$firstDayOfWeek = _ref2.firstDayOfWeek,
      firstDayOfWeek = _ref2$firstDayOfWeek === void 0 ? 0 : _ref2$firstDayOfWeek,
      _ref2$firstWeekContai = _ref2.firstWeekContainsDate,
      firstWeekContainsDate = _ref2$firstWeekContai === void 0 ? 1 : _ref2$firstWeekContai;

  var date = toDate(value);
  var firstDateOfThisWeek = startOfWeek(date, firstDayOfWeek);
  var firstDateOfFirstWeek = startOfWeekYear(date, {
    firstDayOfWeek: firstDayOfWeek,
    firstWeekContainsDate: firstWeekContainsDate
  });
  var diff = firstDateOfThisWeek.getTime() - firstDateOfFirstWeek.getTime();
  return Math.round(diff / (7 * 24 * 3600 * 1000)) + 1;
}

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1564), __esModule: true };

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(957);
__webpack_require__(1565);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(221);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(445);
var createProperty = __webpack_require__(1566);
var getIterFn = __webpack_require__(963);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1557);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);


//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ProbablyOverflowingTextCell.vue",
	data: function data() {
		return {
			data: {},
			uuid: "0",
			init: false,
			interval: null
		};
	},

	computed: {
		text: function text() {
			return this.data[this.data.column.field];
		}
	},
	methods: {
		setVisible: function setVisible() {
			if (this.init) {
				try {
					var e = document.getElementById(this.uuid);
					var res = e.offsetWidth < e.scrollWidth;
					if (res) {
						e._tippy.enable();
					} else {
						e._tippy.disable();
					}
					clearInterval(this.interval);
				} catch (ignored) {}
			}
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							this.uuid = Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["v4"])();
							this.init = true;
							this.interval = setInterval(function () {
								return _this.setVisible();
							}, 50);

						case 3:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1574:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_format_parse__ = __webpack_require__(1582);


function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _extends$1() {
  return _extends$1 = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends$1.apply(this, arguments);
}

var normalMerge = ["attrs", "props", "domProps"],
    toArrayMerge = ["class", "style", "directives"],
    functionalMerge = ["on", "nativeOn"],
    mergeJsxProps = function mergeJsxProps(a) {
  return a.reduce(function (c, a) {
    for (var b in a) {
      if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$1({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
        c[b] = d.concat(e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) {
          if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
                h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
            c[b][f] = g.concat(h);
          } else c[b][f] = a[b][f];
        }
      } else if ("hook" == b) for (var i in a[b]) {
        c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
      } else c[b] = a[b];
    }

    return c;
  }, {});
},
    mergeFn = function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments), b && b.apply(this, arguments);
  };
};

var helper = mergeJsxProps;

// new Date(10, 0, 1) The year from 0 to 99 will be incremented by 1900 automatically.
function createDate(y) {
  var M = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var date = new Date(y, M, d, h, m, s, ms);

  if (y < 100 && y >= 0) {
    date.setFullYear(y);
  }

  return date;
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}
function isValidRangeDate(date) {
  return Array.isArray(date) && date.length === 2 && date.every(isValidDate) && date[0] <= date[1];
}
function isValidDates(dates) {
  return Array.isArray(dates) && dates.every(isValidDate);
}
function getValidDate(value) {
  var date = new Date(value);

  if (isValidDate(date)) {
    return date;
  }

  for (var _len = arguments.length, backup = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    backup[_key - 1] = arguments[_key];
  }

  if (backup.length) {
    return getValidDate.apply(void 0, backup);
  }

  return new Date();
}
function startOfYear(value) {
  var date = new Date(value);
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfMonth(value) {
  var date = new Date(value);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfDay(value) {
  var date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getCalendar(_ref) {
  var firstDayOfWeek = _ref.firstDayOfWeek,
      year = _ref.year,
      month = _ref.month;
  var arr = []; // change to the last day of the last month

  var calendar = createDate(year, month, 0);
  var lastDayInLastMonth = calendar.getDate(); // getDay() 0 is Sunday, 1 is Monday

  var firstDayInLastMonth = lastDayInLastMonth - (calendar.getDay() + 7 - firstDayOfWeek) % 7;

  for (var i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
    arr.push(createDate(year, month, i - lastDayInLastMonth));
  } // change to the last day of the current month


  calendar.setMonth(month + 1, 0);
  var lastDayInCurrentMonth = calendar.getDate();

  for (var _i = 1; _i <= lastDayInCurrentMonth; _i++) {
    arr.push(createDate(year, month, _i));
  }

  var lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
  var nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;

  for (var _i2 = 1; _i2 <= nextMonthLength; _i2++) {
    arr.push(createDate(year, month, lastDayInCurrentMonth + _i2));
  }

  return arr;
}
function setMonth(dirtyDate, dirtyMonth) {
  var date = new Date(dirtyDate);
  var month = typeof dirtyMonth === 'function' ? dirtyMonth(date.getMonth()) : Number(dirtyMonth);
  var year = date.getFullYear();
  var daysInMonth = createDate(year, month + 1, 0).getDate();
  var day = date.getDate();
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
function setYear(dirtyDate, dirtyYear) {
  var date = new Date(dirtyDate);
  var year = typeof dirtyYear === 'function' ? dirtyYear(date.getFullYear()) : dirtyYear;
  date.setFullYear(year);
  return date;
}
function assignTime(target, source) {
  var date = new Date(target);
  var time = new Date(source);
  date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
  return date;
}

/**
 * chunk the array
 * @param {Array} arr
 * @param {Number} size
 */
function chunk(arr, size) {
  if (!Array.isArray(arr)) {
    return [];
  }

  var result = [];
  var len = arr.length;
  var i = 0;
  size = size || len;

  while (i < len) {
    result.push(arr.slice(i, i += size));
  }

  return result;
}
/**
 * isObject
 * @param {*} obj
 * @returns {Boolean}
 */

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */

function pick(obj, props) {
  if (!isObject(obj)) return {};

  if (!Array.isArray(props)) {
    props = [props];
  }

  var res = {};
  props.forEach(function (prop) {
    if (prop in obj) {
      res[prop] = obj[prop];
    }
  });
  return res;
}
/**
 * deep merge two object without merging array
 * @param {object} target
 * @param {object} source
 */

function mergeDeep(target, source) {
  if (!isObject(target)) {
    return {};
  }

  var result = target;

  if (isObject(source)) {
    Object.keys(source).forEach(function (key) {
      var value = source[key];

      if (isObject(value) && isObject(target[key])) {
        value = mergeDeep(target[key], value);
      }

      result = _objectSpread2({}, result, _defineProperty({}, key, value));
    });
  }

  return result;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var en = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;
});

var en$1 = unwrapExports(en);

var lang = {
  formatLocale: en$1,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true
};

var defaultLocale = 'en';
var locales = {};
locales[defaultLocale] = lang;
function locale(name, object, isLocal) {
  if (typeof name !== 'string') return locales[defaultLocale];
  var l = defaultLocale;

  if (locales[name]) {
    l = name;
  }

  if (object) {
    locales[name] = object;
    l = name;
  }

  if (!isLocal) {
    defaultLocale = l;
  }

  return locales[name] || locales[defaultLocale];
}
/**
 * get locale object
 * @param {string} name lang
 */

function getLocale(name) {
  return locale(name, null, true);
}

/* istanbul ignore file */
function rafThrottle(fn) {
  var isRunning = false;
  return function fnBinfRaf() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isRunning) return;
    isRunning = true;
    requestAnimationFrame(function () {
      isRunning = false;
      fn.apply(_this, args);
    });
  };
}

/**
 * get the hidden element width, height
 * @param {HTMLElement} element dom
 */
function getPopupElementSize(element) {
  var originalDisplay = element.style.display;
  var originalVisibility = element.style.visibility;
  element.style.display = 'block';
  element.style.visibility = 'hidden';
  var styles = window.getComputedStyle(element);
  var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
  var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
  element.style.display = originalDisplay;
  element.style.visibility = originalVisibility;
  return {
    width: width,
    height: height
  };
}
/**
 * get the popup position
 * @param {HTMLElement} el relative element
 * @param {Number} targetWidth target element's width
 * @param {Number} targetHeight target element's height
 * @param {Boolean} fixed
 */

function getRelativePosition(el, targetWidth, targetHeight, fixed) {
  var left = 0;
  var top = 0;
  var offsetX = 0;
  var offsetY = 0;
  var relativeRect = el.getBoundingClientRect();
  var dw = document.documentElement.clientWidth;
  var dh = document.documentElement.clientHeight;

  if (fixed) {
    offsetX = window.pageXOffset + relativeRect.left;
    offsetY = window.pageYOffset + relativeRect.top;
  }

  if (dw - relativeRect.left < targetWidth && relativeRect.right < targetWidth) {
    left = offsetX - relativeRect.left + 1;
  } else if (relativeRect.left + relativeRect.width / 2 <= dw / 2) {
    left = offsetX;
  } else {
    left = offsetX + relativeRect.width - targetWidth;
  }

  if (relativeRect.top <= targetHeight && dh - relativeRect.bottom <= targetHeight) {
    top = offsetY + dh - relativeRect.top - targetHeight;
  } else if (relativeRect.top + relativeRect.height / 2 <= dh / 2) {
    top = offsetY + relativeRect.height;
  } else {
    top = offsetY - targetHeight;
  }

  return {
    left: "".concat(left, "px"),
    top: "".concat(top, "px")
  };
}
function getScrollParent(node) {
  var until = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  if (!node || node === until) {
    return null;
  }

  var style = function style(value, prop) {
    return getComputedStyle(value, null).getPropertyValue(prop);
  };

  var regex = /(auto|scroll)/;
  var scroll = regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
  return scroll ? node : getScrollParent(node.parentNode, until);
}

//
var script = {
  name: 'Popup',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      top: '',
      left: ''
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          if (val) {
            _this.displayPopup();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }

    this._clickoutEvent = 'ontouchend' in document ? 'touchstart' : 'mousedown';
    document.addEventListener(this._clickoutEvent, this.handleClickOutside); // change the popup position when resize or scroll

    var relativeElement = this.$parent.$el;
    this._displayPopup = rafThrottle(function () {
      return _this2.displayPopup();
    });
    this._scrollParent = getScrollParent(relativeElement) || window;

    this._scrollParent.addEventListener('scroll', this._displayPopup);

    window.addEventListener('resize', this._displayPopup);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.appendToBody && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }

    document.removeEventListener(this._clickoutEvent, this.handleClickOutside);

    this._scrollParent.removeEventListener('scroll', this._displayPopup);

    window.removeEventListener('resize', this._displayPopup);
  },
  methods: {
    handleClickOutside: function handleClickOutside(evt) {
      if (!this.visible) return;
      var target = evt.target;
      var el = this.$el;

      if (el && !el.contains(target)) {
        this.$emit('clickoutside', evt);
      }
    },
    displayPopup: function displayPopup() {
      if (!this.visible) return;
      var popup = this.$el;
      var relativeElement = this.$parent.$el;
      var appendToBody = this.appendToBody;

      if (!this._popupRect) {
        this._popupRect = getPopupElementSize(popup);
      }

      var _this$_popupRect = this._popupRect,
          width = _this$_popupRect.width,
          height = _this$_popupRect.height;

      var _getRelativePosition = getRelativePosition(relativeElement, width, height, appendToBody),
          left = _getRelativePosition.left,
          top = _getRelativePosition.top;

      this.left = left;
      this.top = top;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": _vm.prefixClass + "-zoom-in-down"
    }
  }, [_vm.visible ? _c('div', {
    class: _vm.prefixClass + "-datepicker-main " + _vm.prefixClass + "-datepicker-popup",
    style: {
      top: _vm.top,
      left: _vm.left,
      position: 'absolute'
    }
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  })]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
    }
  })]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    type: String,
    disabled: Boolean
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    class: [_vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type, {
      disabled: _vm.disabled
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    }
  }, _vm.$listeners), [_c('i', {
    class: _vm.prefixClass + "-icon-" + _vm.type
  })]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$1, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$2 = {
  name: 'TableDate',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    getWeek: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */];
      }
    },
    prefixClass: {
      default: 'mx'
    },
    onDateMouseEnter: {
      default: undefined
    },
    onDateMouseLeave: {
      default: undefined
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    getRowClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    firstDayOfWeek: function firstDayOfWeek() {
      return this.getLocale().formatLocale.firstDayOfWeek || 0;
    },
    yearMonth: function yearMonth() {
      var _this$getLocale = this.getLocale(),
          yearFormat = _this$getLocale.yearFormat,
          monthBeforeYear = _this$getLocale.monthBeforeYear,
          _this$getLocale$month = _this$getLocale.monthFormat,
          monthFormat = _this$getLocale$month === void 0 ? 'MMM' : _this$getLocale$month;

      var yearLabel = {
        panel: 'year',
        label: this.formatDate(this.calendar, yearFormat)
      };
      var monthLabel = {
        panel: 'month',
        label: this.formatDate(this.calendar, monthFormat)
      };
      return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel];
    },
    days: function days() {
      var locale = this.getLocale();
      var days = locale.days || locale.formatLocale.weekdaysMin;
      return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
    },
    dates: function dates() {
      var year = this.calendar.getFullYear();
      var month = this.calendar.getMonth();
      var arr = getCalendar({
        firstDayOfWeek: this.firstDayOfWeek,
        year: year,
        month: month
      });
      return chunk(arr, 7);
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-year':
          date.setFullYear(date.getFullYear() - 1, date.getMonth() + 1, 0);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-year':
          date.setFullYear(date.getFullYear() + 1);
          break;

        case 'last-month':
          date.setMonth(date.getMonth(), 0);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-month':
          date.setMonth(date.getMonth() + 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    handleIconLeftClick: function handleIconLeftClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v - 1;
      }), 'last-month');
    },
    handleIconRightClick: function handleIconRightClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v + 1;
      }), 'next-month');
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange(panel) {
      this.$emit('changepanel', panel);
    },
    handleMouseEnter: function handleMouseEnter(cell) {
      if (typeof this.onDateMouseEnter === 'function') {
        this.onDateMouseEnter(cell);
      }
    },
    handleMouseLeave: function handleMouseLeave(cell) {
      if (typeof this.onDateMouseLeave === 'function') {
        this.onDateMouseLeave(cell);
      }
    },
    handleCellClick: function handleCellClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var index = target.getAttribute('data-row-col');

      if (index) {
        var _index$split$map = index.split(',').map(function (v) {
          return parseInt(v, 10);
        }),
            _index$split$map2 = _slicedToArray(_index$split$map, 2),
            row = _index$split$map2[0],
            col = _index$split$map2[1];

        var date = this.dates[row][col];
        this.$emit('select', new Date(date));
      }
    },
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    getCellTitle: function getCellTitle(date) {
      var fmt = this.titleFormat;
      return this.formatDate(date, fmt);
    },
    getWeekNumber: function getWeekNumber(date) {
      return this.getWeek(date, this.getLocale().formatLocale);
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-date"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-year')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "left",
      "disabled": _vm.isDisabledArrows('last-month')
    },
    on: {
      "click": _vm.handleIconLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-year')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "right",
      "disabled": _vm.isDisabledArrows('next-month')
    },
    on: {
      "click": _vm.handleIconRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, _vm._l(_vm.yearMonth, function (item) {
    return _c('button', {
      key: item.panel,
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-current-" + item.panel,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.handlePanelChange(item.panel);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
  }), 0)], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-date"
  }, [_c('thead', [_c('tr', [_vm.showWeekNumber ? _c('th', {
    class: _vm.prefixClass + "-week-number-header"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.days, function (day) {
    return _c('th', {
      key: day
    }, [_vm._v(_vm._s(day))]);
  })], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "click": _vm.handleCellClick
    }
  }, _vm._l(_vm.dates, function (row, i) {
    return _c('tr', {
      key: i,
      class: [_vm.prefixClass + "-date-row", _vm.getRowClasses(row)]
    }, [_vm.showWeekNumber ? _c('td', {
      class: _vm.prefixClass + "-week-number",
      attrs: {
        "data-row-col": i + ",0"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getWeekNumber(row[0])) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-row-col": i + "," + j,
          "title": _vm.getCellTitle(cell)
        },
        on: {
          "mouseenter": function mouseenter($event) {
            return _vm.handleMouseEnter(cell);
          },
          "mouseleave": function mouseleave($event) {
            return _vm.handleMouseLeave(cell);
          }
        }
      }, [_c('div', [_vm._v(_vm._s(cell.getDate()))])]);
    })], 2);
  }), 0)])])]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$2, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$3 = {
  name: 'TableMonth',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    calendarYear: function calendarYear() {
      return this.calendar.getFullYear();
    },
    months: function months() {
      var locale = this.getLocale();
      var monthsLocale = locale.months || locale.formatLocale.monthsShort;
      var months = monthsLocale.map(function (text, month) {
        return {
          text: text,
          month: month
        };
      });
      return chunk(months, 3);
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-year':
          date.setFullYear(date.getFullYear() - 1, 11, 31);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-year':
          date.setFullYear(date.getFullYear() + 1, 0, 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange() {
      this.$emit('changepanel', 'year');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var month = target.getAttribute('data-month');

      if (month && !target.classList.contains('disabled')) {
        this.$emit('select', parseInt(month, 10));
      }
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-month"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-year')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-year')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handlePanelChange
    }
  }, [_vm._v("\n        " + _vm._s(_vm.calendarYear) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-month",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.months, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell.month),
        attrs: {
          "data-month": cell.month
        }
      }, [_c('div', [_vm._v(_vm._s(cell.text))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$3, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$4 = {
  name: 'TableYear',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getYearPanel: {
      type: Function
    }
  },
  computed: {
    years: function years() {
      var calendar = new Date(this.calendar);

      if (typeof this.getYearPanel === 'function') {
        return this.getYearPanel(calendar);
      }

      return this.getYears(calendar);
    },
    firstYear: function firstYear() {
      return this.years[0][0];
    },
    lastYear: function lastYear() {
      var last = function last(arr) {
        return arr[arr.length - 1];
      };

      return last(last(this.years));
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-decade':
          date.setFullYear(this.firstYear - 1, 11, 31);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-decade':
          date.setFullYear(this.lastYear + 1, 0, 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    getYears: function getYears(calendar) {
      var firstYear = Math.floor(calendar.getFullYear() / 10) * 10;
      var years = [];

      for (var i = 0; i < 10; i++) {
        years.push(firstYear + i);
      }

      return chunk(years, 2);
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 10;
      }), 'last-decade');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 10;
      }), 'next-decade');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var year = target.getAttribute('data-year');

      if (year && !target.classList.contains('disabled')) {
        this.$emit('select', parseInt(year, 10));
      }
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-year"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-decade')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-decade')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.firstYear))]), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-decade-separator"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastYear))])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-year",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.years, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-year": cell
        }
      }, [_c('div', [_vm._v(_vm._s(cell))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$4, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var CalendarPanel = {
  name: 'CalendarPanel',
  inject: {
    prefixClass: {
      default: 'mx'
    },
    dispatchDatePicker: {
      default: function _default() {
        return function () {};
      }
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    defaultPanel: {
      type: String
    },
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    type: {
      type: String,
      default: 'date'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: undefined
    },
    getYearPanel: {
      type: Function
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    calendar: Date,
    // update date when select year or month
    partialUpdate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var panels = ['date', 'month', 'year'];
    var index = Math.max(panels.indexOf(this.type), panels.indexOf(this.defaultPanel));
    var panel = index !== -1 ? panels[index] : 'date';
    return {
      panel: panel,
      innerCalendar: new Date()
    };
  },
  computed: {
    innerValue: function innerValue() {
      var value = Array.isArray(this.value) ? this.value : [this.value];
      var map = {
        year: startOfYear,
        month: startOfMonth,
        date: startOfDay
      };
      var start = map[this.type] || map.date;
      return value.filter(isValidDate).map(function (v) {
        return start(v);
      });
    },
    calendarYear: function calendarYear() {
      return this.innerCalendar.getFullYear();
    },
    calendarMonth: function calendarMonth() {
      return this.innerCalendar.getMonth();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: 'initCalendar'
    },
    calendar: {
      handler: 'initCalendar'
    },
    defaultValue: {
      handler: 'initCalendar'
    }
  },
  methods: {
    initCalendar: function initCalendar() {
      var calendarDate = this.calendar;

      if (!isValidDate(calendarDate)) {
        var length = this.innerValue.length;
        calendarDate = getValidDate(length > 0 ? this.innerValue[length - 1] : this.defaultValue);
      }

      this.innerCalendar = startOfMonth(calendarDate);
    },
    isDisabled: function isDisabled(date) {
      return this.disabledDate(new Date(date), this.innerValue);
    },
    emitDate: function emitDate(date, type) {
      if (!this.isDisabled(date)) {
        this.$emit('select', date, type, this.innerValue); // someone need get the first selected date to set range value. (#429)

        this.dispatchDatePicker('pick', date, type);
      }
    },
    handleCalendarChange: function handleCalendarChange(calendar, type) {
      var oldCalendar = new Date(this.innerCalendar);
      this.innerCalendar = calendar;
      this.$emit('update:calendar', calendar);
      this.dispatchDatePicker('calendar-change', calendar, oldCalendar, type);
    },
    handelPanelChange: function handelPanelChange(panel) {
      var oldPanel = this.panel;
      this.panel = panel;
      this.dispatchDatePicker('panel-change', panel, oldPanel);
    },
    handleSelectYear: function handleSelectYear(year) {
      if (this.type === 'year') {
        var date = this.getYearCellDate(year);
        this.emitDate(date, 'year');
      } else {
        this.handleCalendarChange(createDate(year, this.calendarMonth), 'year');
        this.handelPanelChange('month');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date = new Date(this.innerValue[0]);

          _date.setFullYear(year);

          this.emitDate(_date, 'year');
        }
      }
    },
    handleSelectMonth: function handleSelectMonth(month) {
      if (this.type === 'month') {
        var date = this.getMonthCellDate(month);
        this.emitDate(date, 'month');
      } else {
        this.handleCalendarChange(createDate(this.calendarYear, month), 'month');
        this.handelPanelChange('date');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date2 = new Date(this.innerValue[0]);

          _date2.setFullYear(this.calendarYear);

          this.emitDate(setMonth(_date2, month), 'month');
        }
      }
    },
    handleSelectDate: function handleSelectDate(date) {
      this.emitDate(date, this.type === 'week' ? 'week' : 'date');
    },
    getMonthCellDate: function getMonthCellDate(month) {
      return createDate(this.calendarYear, month);
    },
    getYearCellDate: function getYearCellDate(year) {
      return createDate(year, 0);
    },
    getDateClasses: function getDateClasses(cellDate) {
      var notCurrentMonth = cellDate.getMonth() !== this.calendarMonth;
      var classes = [];

      if (cellDate.getTime() === new Date().setHours(0, 0, 0, 0)) {
        classes.push('today');
      }

      if (notCurrentMonth) {
        classes.push('not-current-month');
      }

      var state = this.getStateClass(cellDate);

      if (!(state === 'active' && notCurrentMonth)) {
        classes.push(state);
      }

      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getMonthClasses: function getMonthClasses(month) {
      var classes = [];

      if (this.type !== 'month') {
        if (this.calendarMonth === month) {
          classes.push('active');
        }

        var _cellDate = this.getMonthCellDate(month);

        if (this.disabledCalendarChanger(_cellDate, 'month')) {
          classes.push('disabled');
        }

        return classes;
      }

      var cellDate = this.getMonthCellDate(month);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getYearClasses: function getYearClasses(year) {
      var classes = [];

      if (this.type !== 'year') {
        if (this.calendarYear === year) {
          classes.push('active');
        }

        var _cellDate2 = this.getYearCellDate(year);

        if (this.disabledCalendarChanger(_cellDate2, 'year')) {
          classes.push('disabled');
        }

        return classes;
      }

      var cellDate = this.getYearCellDate(year);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getStateClass: function getStateClass(cellDate) {
      if (this.isDisabled(cellDate)) {
        return 'disabled';
      }

      if (this.innerValue.some(function (v) {
        return v.getTime() === cellDate.getTime();
      })) {
        return 'active';
      }

      return '';
    },
    getWeekState: function getWeekState(row) {
      if (this.type !== 'week') return '';
      var start = row[0].getTime();
      var end = row[6].getTime();
      var active = this.innerValue.some(function (v) {
        var time = v.getTime();
        return time >= start && time <= end;
      });
      return active ? "".concat(this.prefixClass, "-active-week") : '';
    }
  },
  render: function render() {
    var h = arguments[0];
    var panel = this.panel,
        innerCalendar = this.innerCalendar;

    if (panel === 'year') {
      return h(__vue_component__$7, {
        "attrs": {
          "disabledCalendarChanger": this.disabledCalendarChanger,
          "calendar": innerCalendar,
          "getCellClasses": this.getYearClasses,
          "getYearPanel": this.getYearPanel
        },
        "on": {
          "select": this.handleSelectYear,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    if (panel === 'month') {
      return h(__vue_component__$6, {
        "attrs": {
          "disabledCalendarChanger": this.disabledCalendarChanger,
          "calendar": innerCalendar,
          "getCellClasses": this.getMonthClasses
        },
        "on": {
          "select": this.handleSelectMonth,
          "changepanel": this.handelPanelChange,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    return h(__vue_component__$5, {
      "attrs": {
        "disabledCalendarChanger": this.disabledCalendarChanger,
        "calendar": innerCalendar,
        "getCellClasses": this.getDateClasses,
        "getRowClasses": this.getWeekState,
        "titleFormat": this.titleFormat,
        "showWeekNumber": typeof this.showWeekNumber === 'boolean' ? this.showWeekNumber : this.type === 'week'
      },
      "class": _defineProperty({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === 'week'),
      "on": {
        "select": this.handleSelectDate,
        "changepanel": this.handelPanelChange,
        "changecalendar": this.handleCalendarChange
      }
    });
  }
};

var CalendarRange = {
  name: 'CalendarRange',
  components: {
    CalendarPanel: CalendarPanel
  },
  provide: function provide() {
    return {
      onDateMouseEnter: this.onDateMouseEnter,
      onDateMouseLeave: this.onDateMouseLeave
    };
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, CalendarPanel.props),
  data: function data() {
    return {
      innerValue: [],
      calendars: [],
      hoveredValue: null
    };
  },
  computed: {
    // Minimum difference between start and end calendars
    calendarMinDiff: function calendarMinDiff() {
      var map = {
        date: 1,
        // type:date  min 1 month
        month: 1 * 12,
        // type:month min 1 year
        year: 10 * 12 // type:year  min 10 year

      };
      return map[this.type] || map.date;
    },
    calendarMaxDiff: function calendarMaxDiff() {
      return Infinity;
    },
    defaultValues: function defaultValues() {
      return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        this.innerValue = isValidRangeDate(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
        var calendars = this.innerValue.map(function (v, i) {
          return startOfMonth(getValidDate(v, _this.defaultValues[i]));
        });
        this.updateCalendars(calendars);
      }
    }
  },
  methods: {
    handleSelect: function handleSelect(date, type) {
      var _this$innerValue = _slicedToArray(this.innerValue, 2),
          startValue = _this$innerValue[0],
          endValue = _this$innerValue[1];

      if (isValidDate(startValue) && !isValidDate(endValue)) {
        if (startValue.getTime() > date.getTime()) {
          this.innerValue = [date, startValue];
        } else {
          this.innerValue = [startValue, date];
        }

        this.emitDate(this.innerValue, type);
      } else {
        this.innerValue = [date, new Date(NaN)];
      }
    },
    onDateMouseEnter: function onDateMouseEnter(cell) {
      this.hoveredValue = cell;
    },
    onDateMouseLeave: function onDateMouseLeave() {
      this.hoveredValue = null;
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    updateStartCalendar: function updateStartCalendar(value) {
      this.updateCalendars([value, this.calendars[1]], 1);
    },
    updateEndCalendar: function updateEndCalendar(value) {
      this.updateCalendars([this.calendars[0], value], 0);
    },
    updateCalendars: function updateCalendars(calendars) {
      var adjustIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var gap = this.getCalendarGap(calendars);

      if (gap) {
        var calendar = new Date(calendars[adjustIndex]);
        calendar.setMonth(calendar.getMonth() + (adjustIndex === 0 ? -gap : gap));
        calendars[adjustIndex] = calendar;
      }

      this.calendars = calendars;
    },
    getCalendarGap: function getCalendarGap(calendars) {
      var _calendars = _slicedToArray(calendars, 2),
          calendarLeft = _calendars[0],
          calendarRight = _calendars[1];

      var yearDiff = calendarRight.getFullYear() - calendarLeft.getFullYear();
      var monthDiff = calendarRight.getMonth() - calendarLeft.getMonth();
      var diff = yearDiff * 12 + monthDiff;
      var min = this.calendarMinDiff;
      var max = this.calendarMaxDiff;

      if (diff < min) {
        return min - diff;
      }

      if (diff > max) {
        return max - diff;
      }

      return 0;
    },
    getRangeClasses: function getRangeClasses(cellDate, currentDates, classnames) {
      var classes = [].concat(this.getClasses(cellDate, currentDates, classnames));
      if (/disabled|active/.test(classnames)) return classes;

      var inRange = function inRange(data, range) {
        var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
          return v.getTime();
        };
        var value = fn(data);

        var _range$map = range.map(fn),
            _range$map2 = _slicedToArray(_range$map, 2),
            min = _range$map2[0],
            max = _range$map2[1];

        if (min > max) {
          var _ref = [max, min];
          min = _ref[0];
          max = _ref[1];
        }

        return value > min && value < max;
      };

      if (currentDates.length === 2 && inRange(cellDate, currentDates)) {
        return classes.concat('in-range');
      }

      if (currentDates.length === 1 && this.hoveredValue && inRange(cellDate, [currentDates[0], this.hoveredValue])) {
        return classes.concat('hover-in-range');
      }

      return classes;
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var calendarRange = this.calendars.map(function (calendar, index) {
      var props = _objectSpread2({}, _this2.$props, {
        calendar: calendar,
        value: _this2.innerValue,
        defaultValue: _this2.defaultValues[index],
        getClasses: _this2.getRangeClasses,
        // don't update when range is true
        partialUpdate: false
      });

      var on = {
        select: _this2.handleSelect,
        'update:calendar': index === 0 ? _this2.updateStartCalendar : _this2.updateEndCalendar
      };
      return h("calendar-panel", {
        "props": _objectSpread2({}, props),
        "on": _objectSpread2({}, on)
      });
    });
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [calendarRange]);
  }
};

var scrollBarWidth;
function getScrollbarWidth () {
  if (typeof window === 'undefined') return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  scrollBarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scrollBarWidth;
}

//
var script$5 = {
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  data: function data() {
    return {
      scrollbarWidth: 0,
      thumbTop: '',
      thumbHeight: ''
    };
  },
  created: function created() {
    this.scrollbarWidth = getScrollbarWidth();
    document.addEventListener('mouseup', this.handleDragend);
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('mouseup', this.handleDragend);
  },
  mounted: function mounted() {
    this.$nextTick(this.getThumbSize);
  },
  methods: {
    getThumbSize: function getThumbSize() {
      var wrap = this.$refs.wrap;
      if (!wrap) return;
      var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      this.thumbHeight = heightPercentage < 100 ? "".concat(heightPercentage, "%") : '';
    },
    handleScroll: function handleScroll(evt) {
      var el = evt.currentTarget;
      var scrollHeight = el.scrollHeight,
          scrollTop = el.scrollTop;
      this.thumbTop = "".concat(scrollTop * 100 / scrollHeight, "%");
    },
    handleDragstart: function handleDragstart(evt) {
      evt.stopImmediatePropagation();
      this._draggable = true;
      var offsetTop = this.$refs.thumb.offsetTop;
      this._prevY = evt.clientY - offsetTop;
      document.addEventListener('mousemove', this.handleDraging);
    },
    handleDraging: function handleDraging(evt) {
      if (!this._draggable) return;
      var clientY = evt.clientY;
      var wrap = this.$refs.wrap;
      var scrollHeight = wrap.scrollHeight,
          clientHeight = wrap.clientHeight;
      var offsetY = clientY - this._prevY;
      var top = offsetY * scrollHeight / clientHeight;
      wrap.scrollTop = top;
    },
    handleDragend: function handleDragend() {
      if (this._draggable) {
        this._draggable = false;
        document.removeEventListener('mousemove', this.handleDraging);
      }
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-scrollbar",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, [_c('div', {
    ref: "wrap",
    class: _vm.prefixClass + "-scrollbar-wrap",
    style: {
      marginRight: "-" + _vm.scrollbarWidth + "px"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-scrollbar-track"
  }, [_c('div', {
    ref: "thumb",
    class: _vm.prefixClass + "-scrollbar-thumb",
    style: {
      height: _vm.thumbHeight,
      top: _vm.thumbTop
    },
    on: {
      "mousedown": _vm.handleDragstart
    }
  })])]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$5, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//

var padNumber = function padNumber(value) {
  value = parseInt(value, 10);
  return value < 10 ? "0".concat(value) : "".concat(value);
};

var generateOptions = function generateOptions(length, step, options) {
  if (Array.isArray(options)) {
    return options.filter(function (v) {
      return v >= 0 && v < length;
    });
  }

  if (step <= 0) {
    step = 1;
  }

  var arr = [];

  for (var i = 0; i < length; i += step) {
    arr.push(i);
  }

  return arr;
};

var scrollTo = function scrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // jump to target if duration zero
  if (duration <= 0) {
    requestAnimationFrame(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var tick = difference / duration * 10;
  requestAnimationFrame(function () {
    var scrollTop = element.scrollTop + tick;

    if (scrollTop >= to) {
      element.scrollTop = to;
      return;
    }

    element.scrollTop = scrollTop;
    scrollTo(element, to, duration - 10);
  });
};

var script$6 = {
  name: 'ListColumns',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    scrollDuration: {
      type: Number,
      default: 100
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    showHour: {
      type: Boolean,
      default: true
    },
    showMinute: {
      type: Boolean,
      default: true
    },
    showSecond: {
      type: Boolean,
      default: true
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    use12h: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columns: function columns() {
      var cols = [];
      if (this.showHour) cols.push({
        type: 'hour',
        list: this.getHoursList()
      });
      if (this.showMinute) cols.push({
        type: 'minute',
        list: this.getMinutesList()
      });
      if (this.showSecond) cols.push({
        type: 'second',
        list: this.getSecondsList()
      });
      if (this.use12h) cols.push({
        type: 'ampm',
        list: this.getAMPMList()
      });
      return cols.filter(function (v) {
        return v.list.length > 0;
      });
    }
  },
  watch: {
    date: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          _this.scrollToSelected(_this.scrollDuration);
        });
      }
    }
  },
  mounted: function mounted() {
    this.scrollToSelected(0);
  },
  methods: {
    getHoursList: function getHoursList() {
      var _this2 = this;

      return generateOptions(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function (num) {
        var date = new Date(_this2.date);
        var text = padNumber(num);

        if (_this2.use12h) {
          if (num === 0) {
            text = '12';
          }

          if (date.getHours() >= 12) {
            num += 12;
          }
        }

        var value = date.setHours(num);
        return {
          value: value,
          text: text
        };
      });
    },
    getMinutesList: function getMinutesList() {
      var _this3 = this;

      return generateOptions(60, this.minuteStep, this.minuteOptions).map(function (num) {
        var value = new Date(_this3.date).setMinutes(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getSecondsList: function getSecondsList() {
      var _this4 = this;

      return generateOptions(60, this.secondStep, this.secondOptions).map(function (num) {
        var value = new Date(_this4.date).setSeconds(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getAMPMList: function getAMPMList() {
      var _this5 = this;

      return ['AM', 'PM'].map(function (text, i) {
        var date = new Date(_this5.date);
        var value = date.setHours(date.getHours() % 12 + i * 12);
        return {
          text: text,
          value: value
        };
      });
    },
    scrollToSelected: function scrollToSelected(duration) {
      var elements = this.$el.querySelectorAll('.active');

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var scrollElement = getScrollParent(element, this.$el);

        if (scrollElement) {
          var to = element.offsetTop;
          scrollTo(scrollElement, to, duration);
        }
      }
    },
    handleSelect: function handleSelect(evt) {
      var target = evt.target,
          currentTarget = evt.currentTarget;
      if (target.tagName.toUpperCase() !== 'LI') return;
      var type = currentTarget.getAttribute('data-type');
      var colIndex = parseInt(currentTarget.getAttribute('data-index'), 10);
      var cellIndex = parseInt(target.getAttribute('data-index'), 10);
      var value = this.columns[colIndex].list[cellIndex].value;
      this.$emit('select', value, type);
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time-columns"
  }, _vm._l(_vm.columns, function (col, i) {
    return _c('scrollbar-vertical', {
      key: i,
      class: _vm.prefixClass + "-time-column"
    }, [_c('ul', {
      class: _vm.prefixClass + "-time-list",
      attrs: {
        "data-type": col.type,
        "data-index": i
      },
      on: {
        "click": _vm.handleSelect
      }
    }, _vm._l(col.list, function (item, j) {
      return _c('li', {
        key: item.value,
        class: [_vm.prefixClass + "-time-item", _vm.getClasses(item.value, col.type)],
        attrs: {
          "data-index": j
        }
      }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
    }), 0)]);
  }), 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$6, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//

function parseOption() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = time.split(':');

  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);
    return {
      hours: hours,
      minutes: minutes
    };
  }

  return null;
}

var scrollTo$1 = function scrollTo(element, to) {
  if (element) {
    element.scrollTop = to;
  }
};

var script$7 = {
  name: 'ListOptions',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    options: {
      type: [Object, Function],
      default: function _default() {
        return [];
      }
    },
    format: {
      type: String,
      default: 'HH:mm:ss'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    list: function list() {
      var result = [];
      var options = this.options;

      if (typeof options === 'function') {
        return options() || [];
      }

      var start = parseOption(options.start);
      var end = parseOption(options.end);
      var step = parseOption(options.step);
      var fmt = options.format || this.format;

      if (start && end && step) {
        var startMinutes = start.minutes + start.hours * 60;
        var endMinutes = end.minutes + end.hours * 60;
        var stepMinutes = step.minutes + step.hours * 60;
        var len = Math.floor((endMinutes - startMinutes) / stepMinutes);

        for (var i = 0; i <= len; i++) {
          var timeMinutes = startMinutes + i * stepMinutes;
          var hours = Math.floor(timeMinutes / 60);
          var minutes = timeMinutes % 60;
          var value = new Date(this.date).setHours(hours, minutes, 0);
          result.push({
            value: value,
            text: this.formatDate(value, fmt)
          });
        }
      }

      return result;
    }
  },
  mounted: function mounted() {
    this.scrollToSelected();
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    scrollToSelected: function scrollToSelected() {
      var element = this.$el.querySelector('.active');
      if (!element) return;
      var scrollElement = getScrollParent(element, this.$el);
      if (!scrollElement) return;
      var to = element.offsetTop;
      scrollTo$1(scrollElement, to);
    },
    handleSelect: function handleSelect(value) {
      this.$emit('select', value, 'time');
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('scrollbar-vertical', _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.value,
      class: [_vm.prefixClass + "-time-option", _vm.getClasses(item.value)],
      on: {
        "click": function click($event) {
          return _vm.handleSelect(item.value);
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]);
  }), 0);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$7, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
var script$8 = {
  name: 'TimePanel',
  components: {
    ListColumns: __vue_component__$9,
    ListOptions: __vue_component__$a
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    format: {
      default: 'HH:mm:ss'
    },
    timeTitleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showTimeHeader: {
      type: Boolean,
      default: false
    },
    disabledTime: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    timePickerOptions: {
      type: [Object, Function],
      default: function _default() {
        return null;
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    showHour: {
      type: Boolean,
      default: undefined
    },
    showMinute: {
      type: Boolean,
      default: undefined
    },
    showSecond: {
      type: Boolean,
      default: undefined
    },
    use12h: {
      type: Boolean,
      default: undefined
    },
    scrollDuration: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      innerValue: getValidDate(this.value, this.defaultValue)
    };
  },
  computed: {
    title: function title() {
      var titleFormat = this.timeTitleFormat;
      var date = new Date(this.innerValue);
      return this.formatDate(date, titleFormat);
    },
    innerForamt: function innerForamt() {
      return typeof this.format === 'string' ? this.format : 'HH:mm:ss';
    },
    ShowHourMinuteSecondAMPM: function ShowHourMinuteSecondAMPM() {
      var _this = this;

      var fmt = this.innerForamt;
      var defaultProps = {
        showHour: /[HhKk]/.test(fmt),
        showMinute: /m/.test(fmt),
        showSecond: /s/.test(fmt),
        use12h: /a/i.test(fmt)
      };
      var obj = {};
      Object.keys(defaultProps).forEach(function (key) {
        obj[key] = typeof _this[key] === 'boolean' ? _this[key] : defaultProps[key];
      });
      return obj;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.innerValue = getValidDate(this.value, this.defaultValue);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    isDisabledTime: function isDisabledTime(value) {
      return this.disabledTime(new Date(value));
    },
    isDisabledHour: function isDisabledHour(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setMinutes(0, 0, 0)) && this.isDisabledTime(value.setMinutes(59, 59, 999));
    },
    isDisabledMinute: function isDisabledMinute(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setSeconds(0, 0)) && this.isDisabledTime(value.setSeconds(59, 999));
    },
    isDisabledAMPM: function isDisabledAMPM(date) {
      var value = new Date(date);
      var minHour = value.getHours() < 12 ? 0 : 12;
      var maxHour = minHour + 11;
      return this.isDisabledTime(value) && this.isDisabledTime(value.setHours(minHour, 0, 0, 0)) && this.isDisabledTime(value.setHours(maxHour, 59, 59, 999));
    },
    isDisabled: function isDisabled(date, type) {
      if (type === 'hour') {
        return this.isDisabledHour(date);
      }

      if (type === 'minute') {
        return this.isDisabledMinute(date);
      }

      if (type === 'ampm') {
        return this.isDisabledAMPM(date);
      }

      return this.isDisabledTime(date);
    },
    handleSelect: function handleSelect(value, type) {
      var date = new Date(value);

      if (!this.isDisabled(value, type)) {
        this.innerValue = date;

        if (!this.isDisabledTime(date)) {
          this.$emit('select', date, type);
        }
      }
    },
    handleClickTitle: function handleClickTitle() {
      this.$emit('clicktitle');
    },
    getClasses: function getClasses(value, type) {
      var cellDate = new Date(value);

      if (this.isDisabled(value, type)) {
        return 'disabled';
      }

      if (cellDate.getTime() === this.innerValue.getTime()) {
        return 'active';
      }

      return '';
    }
  }
};

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time"
  }, [_vm.showTimeHeader ? _c('div', {
    class: _vm.prefixClass + "-time-header"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-time-header-title",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClickTitle
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-time-content"
  }, [_vm.timePickerOptions ? _c('list-options', {
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "options": _vm.timePickerOptions,
      "format": _vm.innerForamt
    },
    on: {
      "select": _vm.handleSelect
    }
  }) : _c('list-columns', _vm._b({
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "hour-options": _vm.hourOptions,
      "minute-options": _vm.minuteOptions,
      "second-options": _vm.secondOptions,
      "hour-step": _vm.hourStep,
      "minute-step": _vm.minuteStep,
      "second-step": _vm.secondStep,
      "scroll-duration": _vm.scrollDuration
    },
    on: {
      "select": _vm.handleSelect
    }
  }, 'list-columns', _vm.ShowHourMinuteSecondAMPM, false))], 1)]);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$8, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var TimeRange = {
  name: 'TimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, __vue_component__$b.props),
  data: function data() {
    return {
      startValue: new Date(NaN),
      endValue: new Date(NaN)
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (isValidRangeDate(this.value)) {
          var _this$value = _slicedToArray(this.value, 2),
              startValue = _this$value[0],
              endValue = _this$value[1];

          this.startValue = startValue;
          this.endValue = endValue;
        } else {
          this.startValue = new Date(NaN);
          this.endValue = new Date(NaN);
        }
      }
    }
  },
  methods: {
    emitChange: function emitChange(type, index) {
      var date = [this.startValue, this.endValue];
      this.$emit('select', date, type === 'time' ? 'time-range' : type, index);
    },
    handleSelectStart: function handleSelectStart(date, type) {
      this.startValue = date; // check the NaN

      if (!(this.endValue.getTime() >= date.getTime())) {
        this.endValue = date;
      }

      this.emitChange(type, 0);
    },
    handleSelectEnd: function handleSelectEnd(date, type) {
      // check the NaN
      this.endValue = date;

      if (!(this.startValue.getTime() <= date.getTime())) {
        this.startValue = date;
      }

      this.emitChange(type, 1);
    },
    disabledStartTime: function disabledStartTime(date) {
      return this.disabledTime(date, 0);
    },
    disabledEndTime: function disabledEndTime(date) {
      return date.getTime() < this.startValue.getTime() || this.disabledTime(date, 1);
    }
  },
  render: function render() {
    var h = arguments[0];
    var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.startValue,
        defaultValue: defaultValues[0],
        disabledTime: this.disabledStartTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectStart
      }))
    }), h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.endValue,
        defaultValue: defaultValues[1],
        disabledTime: this.disabledEndTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectEnd
      }))
    })]);
  }
};

var DatetimePanel = {
  name: 'DatetimePanel',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarPanel.props, {}, __vue_component__$b.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(date, type) {
      this.$emit('select', date, type);
    },
    handleSelect: function handleSelect(date, type) {
      if (type === 'date') {
        this.openTimePanel();
      }

      var datetime = assignTime(date, getValidDate(this.value, this.defaultValue));

      if (this.disabledTime(new Date(datetime))) {
        // set the time of defalutValue;
        datetime = assignTime(date, this.defaultValue);

        if (this.disabledTime(new Date(datetime))) {
          // if disabled don't emit date
          this.currentValue = datetime;
          return;
        }
      }

      this.emitDate(datetime, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarPanel.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(__vue_component__$b.props)), {
        showTimeHeader: true,
        value: this.currentValue
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarPanel, helper([{}, calendarProps])), this.timeVisible && h(__vue_component__$b, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var DatetimeRange = {
  name: 'DatetimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarRange.props, {}, TimeRange.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    handleSelect: function handleSelect(dates, type) {
      var _this = this;

      if (type === 'date') {
        this.openTimePanel();
      }

      var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
      var datetimes = dates.map(function (date, i) {
        var time = isValidRangeDate(_this.value) ? _this.value[i] : defaultValues[i];
        return assignTime(date, time);
      });

      if (datetimes[1].getTime() < datetimes[0].getTime()) {
        datetimes = [datetimes[0], datetimes[0]];
      }

      if (datetimes.some(this.disabledTime)) {
        datetimes = dates.map(function (date, i) {
          return assignTime(date, defaultValues[i]);
        });

        if (datetimes.some(this.disabledTime)) {
          this.currentValue = datetimes;
          return;
        }
      }

      this.emitDate(datetimes, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarRange.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(TimeRange.props)), {
        value: this.currentValue,
        showTimeHeader: true
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarRange, helper([{}, calendarProps])), this.timeVisible && h(TimeRange, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var componentMap = {
  default: CalendarPanel,
  time: __vue_component__$b,
  datetime: DatetimePanel
};
var componentRangeMap = {
  default: CalendarRange,
  time: TimeRange,
  datetime: DatetimeRange
};
var DatePicker = {
  name: 'DatePicker',
  provide: function provide() {
    var _this = this;

    return {
      // make locale reactive
      getLocale: function getLocale() {
        return _this.locale;
      },
      getWeek: this.getWeek,
      prefixClass: this.prefixClass,
      dispatchDatePicker: this.$emit.bind(this)
    };
  },
  props: _objectSpread2({}, DatetimePanel.props, {
    value: {},
    valueType: {
      type: String,
      default: 'date' // date, format, timestamp, or token like 'YYYY-MM-DD'

    },
    type: {
      type: String,
      // ['date', 'datetime', 'time', 'year', 'month', 'week']
      default: 'date'
    },
    format: {
      type: String
    },
    formatter: {
      type: Object
    },
    range: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String
    },
    lang: {
      type: [String, Object]
    },
    placeholder: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    prefixClass: {
      type: String,
      default: 'mx'
    },
    inputClass: {},
    inputAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: undefined
    },
    popupClass: {},
    popupStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    renderInputText: {
      type: Function
    },
    shortcuts: {
      type: Array,
      validator: function validator(value) {
        return Array.isArray(value) && value.every(function (v) {
          return isObject(v) && typeof v.text === 'string' && typeof v.onClick === 'function';
        });
      },
      default: function _default() {
        return [];
      }
    }
  }),
  data: function data() {
    return {
      // cache the innervalue, wait to confirm
      currentValue: null,
      userInput: null,
      defaultOpen: false,
      mouseInInput: false
    };
  },
  computed: {
    popupVisible: function popupVisible() {
      return !this.disabled && (typeof this.open === 'boolean' ? this.open : this.defaultOpen);
    },
    innerRangeSeparator: function innerRangeSeparator() {
      return this.rangeSeparator || (this.multiple ? ',' : ' ~ ');
    },
    innerFormat: function innerFormat() {
      var map = {
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm:ss',
        year: 'YYYY',
        month: 'YYYY-MM',
        time: 'HH:mm:ss',
        week: 'w'
      };
      return this.format || map[this.type] || map.date;
    },
    innerValue: function innerValue() {
      var value = this.value;

      if (this.validMultipleType) {
        value = Array.isArray(value) ? value : [];
        return value.map(this.value2date);
      }

      if (this.range) {
        value = Array.isArray(value) ? value.slice(0, 2) : [null, null];
        return value.map(this.value2date);
      }

      return this.value2date(value);
    },
    text: function text() {
      var _this2 = this;

      if (this.userInput !== null) {
        return this.userInput;
      }

      if (typeof this.renderInputText === 'function') {
        return this.renderInputText(this.innerValue);
      }

      if (!this.isValidValue(this.innerValue)) {
        return '';
      }

      if (Array.isArray(this.innerValue)) {
        return this.innerValue.map(function (v) {
          return _this2.formatDate(v);
        }).join(this.innerRangeSeparator);
      }

      return this.formatDate(this.innerValue);
    },
    showClearIcon: function showClearIcon() {
      return !this.disabled && this.clearable && this.text && this.mouseInInput;
    },
    locale: function locale() {
      if (isObject(this.lang)) {
        return mergeDeep(getLocale(), this.lang);
      }

      return getLocale(this.lang);
    },
    validMultipleType: function validMultipleType() {
      var types = ['date', 'month', 'year'];
      return this.multiple && !this.range && types.indexOf(this.type) !== -1;
    }
  },
  watch: {
    innerValue: {
      immediate: true,
      handler: function handler(val) {
        this.currentValue = val;
      }
    },
    popupVisible: {
      handler: function handler(val) {
        if (val) {
          this.currentValue = this.innerValue;
        }
      }
    }
  },
  created: function created() {
    if (_typeof(this.format) === 'object') {
      console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
    }
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.mouseInInput = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.mouseInInput = false;
    },
    handleClickOutSide: function handleClickOutSide(evt) {
      var target = evt.target;

      if (!this.$el.contains(target)) {
        this.closePopup();
      }
    },
    getFormatter: function getFormatter(key) {
      return isObject(this.formatter) && this.formatter[key] || isObject(this.format) && this.format[key];
    },
    getWeek: function getWeek$1(date, options) {
      if (typeof this.getFormatter('getWeek') === 'function') {
        return this.getFormatter('getWeek')(date, options);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */])(date, options);
    },
    parseDate: function parseDate(value, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('parse') === 'function') {
        return this.getFormatter('parse')(value, fmt);
      }

      var backupDate = new Date();
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["c" /* parse */])(value, fmt, {
        locale: this.locale.formatLocale,
        backupDate: backupDate
      });
    },
    formatDate: function formatDate(date, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('stringify') === 'function') {
        return this.getFormatter('stringify')(date, fmt);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.locale.formatLocale
      });
    },
    // transform the outer value to inner date
    value2date: function value2date(value) {
      switch (this.valueType) {
        case 'date':
          return value instanceof Date ? new Date(value.getTime()) : new Date(NaN);

        case 'timestamp':
          return typeof value === 'number' ? new Date(value) : new Date(NaN);

        case 'format':
          return typeof value === 'string' ? this.parseDate(value) : new Date(NaN);

        default:
          return typeof value === 'string' ? this.parseDate(value, this.valueType) : new Date(NaN);
      }
    },
    // transform the inner date to outer value
    date2value: function date2value(date) {
      if (!isValidDate(date)) return null;

      switch (this.valueType) {
        case 'date':
          return date;

        case 'timestamp':
          return date.getTime();

        case 'format':
          return this.formatDate(date);

        default:
          return this.formatDate(date, this.valueType);
      }
    },
    emitValue: function emitValue(date, type) {
      var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
      this.userInput = null;
      var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
      this.$emit('input', value);
      this.$emit('change', value, type);

      if (close) {
        this.closePopup();
      }

      return value;
    },
    isValidValue: function isValidValue(value) {
      if (this.validMultipleType) {
        return isValidDates(value);
      }

      if (this.range) {
        return isValidRangeDate(value);
      }

      return isValidDate(value);
    },
    isValidValueAndNotDisabled: function isValidValueAndNotDisabled(value) {
      if (!this.isValidValue(value)) {
        return false;
      }

      var disabledDate = typeof this.disabledDate === 'function' ? this.disabledDate : function () {
        return false;
      };
      var disabledTime = typeof this.disabledTime === 'function' ? this.disabledTime : function () {
        return false;
      };

      if (!Array.isArray(value)) {
        value = [value];
      }

      return value.every(function (v) {
        return !disabledDate(v) && !disabledTime(v);
      });
    },
    handleMultipleDates: function handleMultipleDates(date, dates) {
      if (this.validMultipleType && dates) {
        var nextDates = dates.filter(function (v) {
          return v.getTime() !== date.getTime();
        });

        if (nextDates.length === dates.length) {
          nextDates.push(date);
        }

        return nextDates;
      }

      return date;
    },
    handleSelectDate: function handleSelectDate(val, type, dates) {
      val = this.handleMultipleDates(val, dates);

      if (this.confirm) {
        this.currentValue = val;
      } else {
        this.emitValue(val, type, // this.type === 'datetime', click the time should close popup
        !this.validMultipleType && (type === this.type || type === 'time'));
      }
    },
    clear: function clear() {
      this.emitValue(this.range ? [null, null] : null);
      this.$emit('clear');
    },
    handleClear: function handleClear(evt) {
      evt.stopPropagation();
      this.clear();
    },
    handleConfirmDate: function handleConfirmDate() {
      var value = this.emitValue(this.currentValue);
      this.$emit('confirm', value);
    },
    handleSelectShortcut: function handleSelectShortcut(evt) {
      var index = evt.currentTarget.getAttribute('data-index');
      var item = this.shortcuts[parseInt(index, 10)];

      if (isObject(item) && typeof item.onClick === 'function') {
        var date = item.onClick(this);

        if (date) {
          this.emitValue(date);
        }
      }
    },
    openPopup: function openPopup(evt) {
      if (this.popupVisible || this.disabled) return;
      this.defaultOpen = true;
      this.$emit('open', evt);
      this.$emit('update:open', true);
    },
    closePopup: function closePopup() {
      if (!this.popupVisible) return;
      this.defaultOpen = false;
      this.$emit('close');
      this.$emit('update:open', false);
    },
    blur: function blur() {
      // when use slot input
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    focus: function focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    handleInputChange: function handleInputChange() {
      var _this3 = this;

      if (!this.editable || this.userInput === null) return;
      var text = this.userInput.trim();
      this.userInput = null;

      if (text === '') {
        this.clear();
        return;
      }

      var date;

      if (this.validMultipleType) {
        date = text.split(this.innerRangeSeparator).map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else if (this.range) {
        var arr = text.split(this.innerRangeSeparator);

        if (arr.length !== 2) {
          // Maybe the separator during the day is the same as the separator for the date
          // eg: 2019-10-09-2020-01-02
          arr = text.split(this.innerRangeSeparator.trim());
        }

        date = arr.map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else {
        date = this.parseDate(text);
      }

      if (this.isValidValueAndNotDisabled(date)) {
        this.emitValue(date);
        this.blur();
      } else {
        this.$emit('input-error', text);
      }
    },
    handleInputInput: function handleInputInput(evt) {
      // slot input v-model
      this.userInput = typeof evt === 'string' ? evt : evt.target.value;
    },
    handleInputKeydown: function handleInputKeydown(evt) {
      var keyCode = evt.keyCode; // Tab 9 or Enter 13

      if (keyCode === 9) {
        this.closePopup();
      } else if (keyCode === 13) {
        this.handleInputChange();
      }
    },
    handleInputBlur: function handleInputBlur(evt) {
      // tab close
      this.$emit('blur', evt);
    },
    handleInputFocus: function handleInputFocus(evt) {
      this.openPopup(evt);
      this.$emit('focus', evt);
    },
    hasSlot: function hasSlot(name) {
      return !!(this.$slots[name] || this.$scopedSlots[name]);
    },
    renderSlot: function renderSlot(name, fallback, props) {
      var slotFn = this.$scopedSlots[name];

      if (slotFn) {
        return slotFn(props) || fallback;
      }

      return this.$slots[name] || fallback;
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;

      var props = _objectSpread2({
        name: 'date',
        type: 'text',
        autocomplete: 'off',
        value: this.text,
        class: this.inputClass || "".concat(this.prefixClass, "-input"),
        readonly: !this.editable,
        disabled: this.disabled,
        placeholder: this.placeholder
      }, this.inputAttr);

      var value = props.value,
          className = props.class,
          attrs = _objectWithoutProperties(props, ["value", "class"]);

      var events = {
        keydown: this.handleInputKeydown,
        focus: this.handleInputFocus,
        blur: this.handleInputBlur,
        input: this.handleInputInput,
        change: this.handleInputChange
      };
      var input = this.renderSlot('input', h("input", {
        "domProps": {
          "value": value
        },
        "class": className,
        "attrs": _objectSpread2({}, attrs),
        "on": _objectSpread2({}, events),
        "ref": "input"
      }), {
        props: props,
        events: events
      });
      var calendarIcon = this.type === 'time' ? h(__vue_component__$2) : h(__vue_component__$1); // remove touchstart event to avoid opens the popup while scrolling in mobile #469

      return h("div", {
        "class": "".concat(prefixClass, "-input-wrapper"),
        "on": {
          "mouseenter": this.handleMouseEnter,
          "mouseleave": this.handleMouseLeave,
          "click": this.openPopup
        },
        "ref": "inputWrapper"
      }, [input, this.showClearIcon ? h("i", {
        "class": "".concat(prefixClass, "-icon-clear"),
        "on": {
          "click": this.handleClear
        }
      }, [this.renderSlot('icon-clear', h(__vue_component__$3))]) : h("i", {
        "class": "".concat(prefixClass, "-icon-calendar")
      }, [this.renderSlot('icon-calendar', calendarIcon)])]);
    },
    renderContent: function renderContent() {
      var h = this.$createElement;
      var map = this.range ? componentRangeMap : componentMap;
      var Component = map[this.type] || map.default;

      var props = _objectSpread2({}, pick(this.$props, Object.keys(Component.props)), {
        value: this.currentValue
      });

      var on = _objectSpread2({}, pick(this.$listeners, Component.emits || []), {
        select: this.handleSelectDate
      });

      var content = h(Component, helper([{}, {
        props: props,
        on: on,
        ref: 'picker'
      }]));
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-body")
      }, [this.renderSlot('content', content, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderSidebar: function renderSidebar() {
      var _this4 = this;

      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-sidebar")
      }, [this.renderSlot('sidebar', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.shortcuts.map(function (v, i) {
        return h("button", {
          "key": i,
          "attrs": {
            "data-index": i,
            "type": "button"
          },
          "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-btn-text ").concat(prefixClass, "-btn-shortcut"),
          "on": {
            "click": _this4.handleSelectShortcut
          }
        }, [v.text]);
      })]);
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-header")
      }, [this.renderSlot('header', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderFooter: function renderFooter() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-footer")
      }, [this.renderSlot('footer', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.confirm ? h("button", {
        "attrs": {
          "type": "button"
        },
        "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-datepicker-btn-confirm"),
        "on": {
          "click": this.handleConfirmDate
        }
      }, [this.confirmText]) : null]);
    }
  },
  render: function render() {
    var _class;

    var h = arguments[0];
    var prefixClass = this.prefixClass,
        inline = this.inline,
        disabled = this.disabled;
    var sidedar = this.hasSlot('sidebar') || this.shortcuts.length ? this.renderSidebar() : null;
    var content = h("div", {
      "class": "".concat(prefixClass, "-datepicker-content")
    }, [this.hasSlot('header') ? this.renderHeader() : null, this.renderContent(), this.hasSlot('footer') || this.confirm ? this.renderFooter() : null]);
    return h("div", {
      "class": (_class = {}, _defineProperty(_class, "".concat(prefixClass, "-datepicker"), true), _defineProperty(_class, "".concat(prefixClass, "-datepicker-range"), this.range), _defineProperty(_class, "".concat(prefixClass, "-datepicker-inline"), inline), _defineProperty(_class, "disabled", disabled), _class)
    }, [!inline ? this.renderInput() : null, !inline ? h(__vue_component__, {
      "ref": "popup",
      "class": this.popupClass,
      "style": this.popupStyle,
      "attrs": {
        "visible": this.popupVisible,
        "appendToBody": this.appendToBody
      },
      "on": {
        "clickoutside": this.handleClickOutSide
      }
    }, [sidedar, content]) : h("div", {
      "class": "".concat(prefixClass, "-datepicker-main")
    }, [sidedar, content])]);
  }
};

DatePicker.locale = locale;

DatePicker.install = function install(Vue) {
  Vue.component(DatePicker.name, DatePicker);
};

if (typeof window !== 'undefined' && window.Vue) {
  DatePicker.install(window.Vue);
}

_extends(DatePicker, {
  CalendarPanel: CalendarPanel,
  CalendarRange: CalendarRange,
  TimePanel: __vue_component__$b,
  TimeRange: TimeRange,
  DatetimePanel: DatetimePanel,
  DatetimeRange: DatetimeRange
});

/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1579), __esModule: true };

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1580);
module.exports = __webpack_require__(105).Object.keys;


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(954);
var $keys = __webpack_require__(955);

__webpack_require__(1581)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(183);
var core = __webpack_require__(105);
var fails = __webpack_require__(442);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 1582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format__ = __webpack_require__(1583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__parse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1556);
/* unused harmony reexport isDate */
/* unused harmony reexport toDate */
/* unused harmony reexport isValidDate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["a"]; });




/***/ }),

/***/ 1583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en__ = __webpack_require__(1567);


var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;

function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var output = "".concat(Math.abs(val));
  var sign = val < 0 ? '-' : '';

  while (output.length < len) {
    output = "0".concat(output);
  }

  return sign + output;
}

function getOffset(date) {
  return Math.round(date.getTimezoneOffset() / 15) * 15;
}

function formatTimezone(offset) {
  var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + pad(hours, 2) + delimeter + pad(minutes, 2);
}

var meridiem = function meridiem(h, _, isLowercase) {
  var word = h < 12 ? 'AM' : 'PM';
  return isLowercase ? word.toLocaleLowerCase() : word;
};

var formatFlags = {
  Y: function Y(date) {
    var y = date.getFullYear();
    return y <= 9999 ? "".concat(y) : "+".concat(y);
  },
  // Year: 00, 01, ..., 99
  YY: function YY(date) {
    return pad(date.getFullYear(), 4).substr(2);
  },
  // Year: 1900, 1901, ..., 2099
  YYYY: function YYYY(date) {
    return pad(date.getFullYear(), 4);
  },
  // Month: 1, 2, ..., 12
  M: function M(date) {
    return date.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM: function MM(date) {
    return pad(date.getMonth() + 1, 2);
  },
  MMM: function MMM(date, locale) {
    return locale.monthsShort[date.getMonth()];
  },
  MMMM: function MMMM(date, locale) {
    return locale.months[date.getMonth()];
  },
  // Day of month: 1, 2, ..., 31
  D: function D(date) {
    return date.getDate();
  },
  // Day of month: 01, 02, ..., 31
  DD: function DD(date) {
    return pad(date.getDate(), 2);
  },
  // Hour: 0, 1, ... 23
  H: function H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH: function HH(date) {
    return pad(date.getHours(), 2);
  },
  // Hour: 1, 2, ..., 12
  h: function h(date) {
    var hours = date.getHours();

    if (hours === 0) {
      return 12;
    }

    if (hours > 12) {
      return hours % 12;
    }

    return hours;
  },
  // Hour: 01, 02, ..., 12
  hh: function hh() {
    var hours = formatFlags.h.apply(formatFlags, arguments);
    return pad(hours, 2);
  },
  // Minute: 0, 1, ..., 59
  m: function m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm: function mm(date) {
    return pad(date.getMinutes(), 2);
  },
  // Second: 0, 1, ..., 59
  s: function s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss: function ss(date) {
    return pad(date.getSeconds(), 2);
  },
  // 1/10 of second: 0, 1, ..., 9
  S: function S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS: function SS(date) {
    return pad(Math.floor(date.getMilliseconds() / 10), 2);
  },
  // Millisecond: 000, 001, ..., 999
  SSS: function SSS(date) {
    return pad(date.getMilliseconds(), 3);
  },
  // Day of week: 0, 1, ..., 6
  d: function d(date) {
    return date.getDay();
  },
  // Day of week: 'Su', 'Mo', ..., 'Sa'
  dd: function dd(date, locale) {
    return locale.weekdaysMin[date.getDay()];
  },
  // Day of week: 'Sun', 'Mon',..., 'Sat'
  ddd: function ddd(date, locale) {
    return locale.weekdaysShort[date.getDay()];
  },
  // Day of week: 'Sunday', 'Monday', ...,'Saturday'
  dddd: function dddd(date, locale) {
    return locale.weekdays[date.getDay()];
  },
  // AM, PM
  A: function A(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), false);
  },
  // am, pm
  a: function a(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), true);
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z: function Z(date) {
    return formatTimezone(getOffset(date), ':');
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ: function ZZ(date) {
    return formatTimezone(getOffset(date));
  },
  // Seconds timestamp: 512969520
  X: function X(date) {
    return Math.floor(date.getTime() / 1000);
  },
  // Milliseconds timestamp: 512969520900
  x: function x(date) {
    return date.getTime();
  },
  w: function w(date, locale) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* getWeek */])(date, {
      firstDayOfWeek: locale.firstDayOfWeek,
      firstWeekContainsDate: locale.firstWeekContainsDate
    });
  },
  ww: function ww(date, locale) {
    return pad(formatFlags.w(date, locale), 2);
  }
};
function format(val, str) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var formatStr = str ? String(str) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* toDate */])(val);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isValidDate */])(date)) {
    return 'Invalid Date';
  }

  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en__["a" /* default */];
  return formatStr.replace(REGEX_FORMAT, function (match, p1) {
    if (p1) {
      return p1;
    }

    if (typeof formatFlags[match] === 'function') {
      return "".concat(formatFlags[match](date, locale));
    }

    return match;
  });
}

/***/ }),

/***/ 1584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1556);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var formattingTokens = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g;
var match1 = /\d/; // 0 - 9

var match2 = /\d\d/; // 00 - 99

var match3 = /\d{3}/; // 000 - 999

var match4 = /\d{4}/; // 0000 - 9999

var match1to2 = /\d\d?/; // 0 - 99

var matchShortOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000

var matchSigned = /[+-]?\d+/; // -inf - inf

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
// const matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i; // Word

var YEAR = 'year';
var MONTH = 'month';
var DAY = 'day';
var HOUR = 'hour';
var MINUTE = 'minute';
var SECOND = 'second';
var MILLISECOND = 'millisecond';
var parseFlags = {};

var addParseFlag = function addParseFlag(token, regex, callback) {
  var tokens = Array.isArray(token) ? token : [token];
  var func;

  if (typeof callback === 'string') {
    func = function func(input) {
      var value = parseInt(input, 10);
      return _defineProperty({}, callback, value);
    };
  } else {
    func = callback;
  }

  tokens.forEach(function (key) {
    parseFlags[key] = [regex, func];
  });
};

var escapeStringRegExp = function escapeStringRegExp(str) {
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

var matchWordRegExp = function matchWordRegExp(localeKey) {
  return function (locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    return new RegExp(array.map(escapeStringRegExp).join('|'));
  };
};

var matchWordCallback = function matchWordCallback(localeKey, key) {
  return function (input, locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    var index = array.indexOf(input);

    if (index < 0) {
      throw new Error('Invalid Word');
    }

    return _defineProperty({}, key, index);
  };
};

addParseFlag('Y', matchSigned, YEAR);
addParseFlag('YY', match2, function (input) {
  var year = new Date().getFullYear();
  var cent = Math.floor(year / 100);
  var value = parseInt(input, 10);
  value = (value > 68 ? cent - 1 : cent) * 100 + value;
  return _defineProperty({}, YEAR, value);
});
addParseFlag('YYYY', match4, YEAR);
addParseFlag('M', match1to2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MM', match2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MMM', matchWordRegExp('monthsShort'), matchWordCallback('monthsShort', MONTH));
addParseFlag('MMMM', matchWordRegExp('months'), matchWordCallback('months', MONTH));
addParseFlag('D', match1to2, DAY);
addParseFlag('DD', match2, DAY);
addParseFlag(['H', 'h'], match1to2, HOUR);
addParseFlag(['HH', 'hh'], match2, HOUR);
addParseFlag('m', match1to2, MINUTE);
addParseFlag('mm', match2, MINUTE);
addParseFlag('s', match1to2, SECOND);
addParseFlag('ss', match2, SECOND);
addParseFlag('S', match1, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 100);
});
addParseFlag('SS', match2, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 10);
});
addParseFlag('SSS', match3, MILLISECOND);

function matchMeridiem(locale) {
  return locale.meridiemParse || /[ap]\.?m?\.?/i;
}

function defaultIsPM(input) {
  return "".concat(input).toLowerCase().charAt(0) === 'p';
}

addParseFlag(['A', 'a'], matchMeridiem, function (input, locale) {
  var isPM = typeof locale.isPM === 'function' ? locale.isPM(input) : defaultIsPM(input);
  return {
    isPM: isPM
  };
});

function offsetFromString(str) {
  var _ref8 = str.match(/([+-]|\d\d)/g) || ['-', '0', '0'],
      _ref9 = _slicedToArray(_ref8, 3),
      symbol = _ref9[0],
      hour = _ref9[1],
      minute = _ref9[2];

  var minutes = parseInt(hour, 10) * 60 + parseInt(minute, 10);

  if (minutes === 0) {
    return 0;
  }

  return symbol === '+' ? -minutes : +minutes;
}

addParseFlag(['Z', 'ZZ'], matchShortOffset, function (input) {
  return {
    offset: offsetFromString(input)
  };
});
addParseFlag('x', matchSigned, function (input) {
  return {
    date: new Date(parseInt(input, 10))
  };
});
addParseFlag('X', matchTimestamp, function (input) {
  return {
    date: new Date(parseFloat(input) * 1000)
  };
});
addParseFlag('d', match1, 'weekday');
addParseFlag('dd', matchWordRegExp('weekdaysMin'), matchWordCallback('weekdaysMin', 'weekday'));
addParseFlag('ddd', matchWordRegExp('weekdaysShort'), matchWordCallback('weekdaysShort', 'weekday'));
addParseFlag('dddd', matchWordRegExp('weekdays'), matchWordCallback('weekdays', 'weekday'));
addParseFlag('w', match1to2, 'week');
addParseFlag('ww', match2, 'week');

function to24hour(hour, isPM) {
  if (hour !== undefined && isPM !== undefined) {
    if (isPM) {
      if (hour < 12) {
        return hour + 12;
      }
    } else if (hour === 12) {
      return 0;
    }
  }

  return hour;
}

function getFullInputArray(input) {
  var backupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var result = [0, 0, 1, 0, 0, 0, 0];
  var backupArr = [backupDate.getFullYear(), backupDate.getMonth(), backupDate.getDate(), backupDate.getHours(), backupDate.getMinutes(), backupDate.getSeconds(), backupDate.getMilliseconds()];
  var useBackup = true;

  for (var i = 0; i < 7; i++) {
    if (input[i] === undefined) {
      result[i] = useBackup ? backupArr[i] : result[i];
    } else {
      result[i] = input[i];
      useBackup = false;
    }
  }

  return result;
}

function createDate(y, m, d, h, M, s, ms) {
  var date;

  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h, M, s, ms);

    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h, M, s, ms);
  }

  return date;
}

function createUTCDate() {
  var date;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var y = args[0];

  if (y < 100 && y >= 0) {
    args[0] += 400;
    date = new Date(Date.UTC.apply(Date, args)); // eslint-disable-next-line no-restricted-globals

    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(Date, args));
  }

  return date;
}

function makeParser(dateString, format, locale) {
  var tokens = format.match(formattingTokens);

  if (!tokens) {
    throw new Error();
  }

  var length = tokens.length;
  var mark = {};

  for (var i = 0; i < length; i += 1) {
    var token = tokens[i];
    var parseTo = parseFlags[token];

    if (!parseTo) {
      var word = token.replace(/^\[|\]$/g, '');

      if (dateString.indexOf(word) === 0) {
        dateString = dateString.substr(word.length);
      } else {
        throw new Error('not match');
      }
    } else {
      var regex = typeof parseTo[0] === 'function' ? parseTo[0](locale) : parseTo[0];
      var parser = parseTo[1];
      var value = (regex.exec(dateString) || [])[0];
      var obj = parser(value, locale);
      mark = _objectSpread({}, mark, {}, obj);
      dateString = dateString.replace(value, '');
    }
  }

  return mark;
}

function parse(str, format) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  try {
    var _options$locale = options.locale,
        _locale = _options$locale === void 0 ? __WEBPACK_IMPORTED_MODULE_0__locale_en__["a" /* default */] : _options$locale,
        _options$backupDate = options.backupDate,
        backupDate = _options$backupDate === void 0 ? new Date() : _options$backupDate;

    var parseResult = makeParser(str, format, _locale);
    var year = parseResult.year,
        month = parseResult.month,
        day = parseResult.day,
        hour = parseResult.hour,
        minute = parseResult.minute,
        second = parseResult.second,
        millisecond = parseResult.millisecond,
        isPM = parseResult.isPM,
        date = parseResult.date,
        offset = parseResult.offset,
        weekday = parseResult.weekday,
        week = parseResult.week;

    if (date) {
      return date;
    }

    var inputArray = [year, month, day, hour, minute, second, millisecond];
    inputArray[3] = to24hour(inputArray[3], isPM); // check week

    if (week !== undefined && month === undefined && day === undefined) {
      // new Date(year, 3) make sure in current year
      var firstDate = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* startOfWeekYear */])(year === undefined ? backupDate : new Date(year, 3), {
        firstDayOfWeek: _locale.firstDayOfWeek,
        firstWeekContainsDate: _locale.firstWeekContainsDate
      });
      return new Date(firstDate.getTime() + (week - 1) * 7 * 24 * 3600 * 1000);
    }

    var parsedDate;
    var result = getFullInputArray(inputArray, backupDate);

    if (offset !== undefined) {
      result[6] += offset * 60 * 1000;
      parsedDate = createUTCDate.apply(void 0, _toConsumableArray(result));
    } else {
      parsedDate = createDate.apply(void 0, _toConsumableArray(result));
    } // check weekday


    if (weekday !== undefined && parsedDate.getDay() !== weekday) {
      return new Date(NaN);
    }

    return parsedDate;
  } catch (e) {
    return new Date(NaN);
  }
}

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1594);
var v4 = __webpack_require__(1595);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 1589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1596);
function injectStyle (ssrContext) {
  __webpack_require__(1590)
  __webpack_require__(1592)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e2e6411"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("28d11c4b", content, true, {});

/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow{border-bottom:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,iFACC,+BAAiC,CACjC","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-bottom: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("42116436", content, true, {});

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme[data-v-6e2e6411]{background-color:#346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,kDACC,wBAA0B,CAC1B","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme[data-v-6e2e6411] {\n\tbackground-color: #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1574);
var bytesToUuid = __webpack_require__(1575);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1574);
var bytesToUuid = __webpack_require__(1575);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'bottom-start', arrow : true }),expression:"{ theme : 'customTheme', placement : 'bottom-start', arrow : true }"}],staticStyle:{"text-overflow":"ellipsis","width":"100%","overflow":"hidden"},attrs:{"id":_vm.uuid,"content":_vm.text}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(451)('meta');
var isObject = __webpack_require__(185);
var has = __webpack_require__(223);
var setDesc = __webpack_require__(184).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(442)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(185);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(224);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1676:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1677), __esModule: true };

/***/ }),

/***/ 1677:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(973);
__webpack_require__(957);
__webpack_require__(969);
__webpack_require__(1678);
__webpack_require__(1684);
__webpack_require__(1687);
__webpack_require__(1689);
module.exports = __webpack_require__(105).Set;


/***/ }),

/***/ 1678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1679);
var validate = __webpack_require__(1615);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1680)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(184).f;
var create = __webpack_require__(974);
var redefineAll = __webpack_require__(972);
var ctx = __webpack_require__(221);
var anInstance = __webpack_require__(971);
var forOf = __webpack_require__(964);
var $iterDefine = __webpack_require__(453);
var step = __webpack_require__(975);
var setSpecies = __webpack_require__(976);
var DESCRIPTORS = __webpack_require__(154);
var fastKey = __webpack_require__(1605).fastKey;
var validate = __webpack_require__(1615);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(80);
var $export = __webpack_require__(183);
var meta = __webpack_require__(1605);
var fails = __webpack_require__(442);
var hide = __webpack_require__(155);
var redefineAll = __webpack_require__(972);
var forOf = __webpack_require__(964);
var anInstance = __webpack_require__(971);
var isObject = __webpack_require__(185);
var setToStringTag = __webpack_require__(298);
var dP = __webpack_require__(184).f;
var each = __webpack_require__(1681)(0);
var DESCRIPTORS = __webpack_require__(154);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1681:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(221);
var IObject = __webpack_require__(959);
var toObject = __webpack_require__(954);
var toLength = __webpack_require__(445);
var asc = __webpack_require__(1682);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1683);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1683:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(185);
var isArray = __webpack_require__(1648);
var SPECIES = __webpack_require__(87)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(183);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1685)('Set') });


/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(452);
var from = __webpack_require__(1686);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(964);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1687:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1688)('Set');


/***/ }),

/***/ 1688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1690)('Set');


/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);
var aFunction = __webpack_require__(225);
var ctx = __webpack_require__(221);
var forOf = __webpack_require__(964);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1709:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1710), __esModule: true };

/***/ }),

/***/ 1710:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(969);
__webpack_require__(957);
module.exports = __webpack_require__(1711);


/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(134);
var get = __webpack_require__(963);
module.exports = __webpack_require__(105).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GROUP_GAP_MS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TicketStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_KEYS; });
/* harmony export (immutable) */ __webpack_exports__["g"] = parseUtc;
/* harmony export (immutable) */ __webpack_exports__["e"] = dayKey;
/* harmony export (immutable) */ __webpack_exports__["f"] = initials;
/* harmony export (immutable) */ __webpack_exports__["d"] = buildTimeline;
/* harmony export (immutable) */ __webpack_exports__["h"] = sendErrorKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


// Logika czatu zgłoszeń bez zależności od Vue — układanie wątku w oś czasu
// (separatory dni, zdarzenia, serie wiadomości jednego autora).

// Kolejne wiadomości tego samego autora w tym odstępie są zlepiane w jedną serię.
var GROUP_GAP_MS = 5 * 60 * 1000;

// Status zgłoszenia (enum TicketStatus w API) → klucz tłumaczenia.
var STATUS_KEYS = ['TicketStatusNew', 'TicketStatusOngoing', 'TicketStatusWaitingForApprove', 'TicketStatusRejected', 'TicketStatusClosed'];

var TicketStatus = { New: 0, Ongoing: 1, WaitingForApprove: 2, Rejected: 3, Closed: 4

    // Zdarzenia zapisuje backend po angielsku (TicketsService). W bazie zostają bez zmian,
    // bo czyta je też aplikacja mobilna — tłumaczymy znane teksty tutaj.
};var EVENT_KEYS = {
    'Requested to approve.': 'TicketEventRequestedClose',
    'Ticket closed.': 'TicketEventClosed',
    'Confirmed close.': 'TicketEventConfirmedClose',
    'Request to close denied.': 'TicketEventCloseDenied'

    // Daty przychodzą z API jako UTC bez strefy ("2026-09-24T10:15:00"). Bez dopisania "Z"
    // przeglądarka wzięłaby je za czas lokalny i godziny rozjechałyby się o offset.
};function parseUtc(value) {
    if (value instanceof Date) return value;
    if (value == null) return null;
    var text = String(value);
    return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(text) ? text : text + 'Z');
}

function dayKey(date) {
    return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
}

function initials(name) {
    var parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    return parts.slice(0, 2).map(function (p) {
        return p[0].toUpperCase();
    }).join('');
}

/**
 * Zamienia listę wiadomości na elementy do wyświetlenia:
 *  { type: 'day', key, date }
 *  { type: 'event', key, message }
 *  { type: 'message', key, message, mine, startsGroup, endsGroup }
 * Wiadomości muszą mieć `sentDate` jako Date.
 */
function buildTimeline(messages, myUserId) {
    var sorted = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(messages)).sort(function (a, b) {
        return a.sentDate - b.sentDate;
    });
    var items = [];
    var lastDay = null;
    var lastMessageItem = null;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sorted), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var message = _step.value;

            var day = dayKey(message.sentDate);
            if (day !== lastDay) {
                items.push({ type: 'day', key: 'day-' + day, date: message.sentDate });
                lastDay = day;
                lastMessageItem = null;
            }

            if (message.isEvent) {
                items.push({ type: 'event', key: message.id, message: message });
                lastMessageItem = null;
                continue;
            }

            var continuesGroup = lastMessageItem != null && lastMessageItem.message.creatorId === message.creatorId && message.sentDate - lastMessageItem.message.sentDate <= GROUP_GAP_MS;

            if (continuesGroup) {
                lastMessageItem.endsGroup = false;
            }

            lastMessageItem = {
                type: 'message',
                key: message.id,
                message: message,
                mine: message.creatorId === myUserId,
                startsGroup: !continuesGroup,
                endsGroup: true
            };
            items.push(lastMessageItem);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return items;
}

// Klucz tłumaczenia dla nieudanej wysyłki (nowe zgłoszenie albo odpowiedź).
// 413 = za duże żądanie; brak odpowiedzi = zerwane połączenie, co przy dużych zdjęciach
// też zwykle oznacza limit po drodze.
function sendErrorKey(error, hasPhotos) {
    var status = error && error.response ? error.response.status : null;
    if (status === 413) return 'PhotosTooLarge';
    if (status == null && hasPhotos) return 'PhotosUploadFailed';
    return 'SendFailed';
}

/***/ }),

/***/ 1885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Systems_ProbablyOverflowingTextCell__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Systems_Tickets_TicketModal_vue__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Systems_Tickets_TicketChat_vue__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Systems_Tickets_ticketChat__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		systemName: {
			required: false,
			type: String
		},
		systemId: {
			required: false,
			type: String
		}
	},
	provide: {
		grid: [__WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
	},
	components: {
		ProbablyOverflowingTextCell: __WEBPACK_IMPORTED_MODULE_4__components_Systems_ProbablyOverflowingTextCell__["a" /* default */],
		Modal: __WEBPACK_IMPORTED_MODULE_8__components_Modal_vue__["a" /* default */],
		TicketModal: __WEBPACK_IMPORTED_MODULE_5__components_Systems_Tickets_TicketModal_vue__["a" /* default */],
		TicketChat: __WEBPACK_IMPORTED_MODULE_6__components_Systems_Tickets_TicketChat_vue__["a" /* default */]
	},
	data: function data() {
		return {
			// Creator, CreateDate, AssigneeName, SystemName, Status, Subject, Content, MessagesCount, IsRead, LastMessageDate
			tickets: [],
			mode: 'Active',
			activeModal: 'NONE',
			selectedTicket: null,

			customAttributes: { class: 'customcss' },
			dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm', type: 'dateTime' },
			pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			sortSettings: { columns: [{ field: 'lastMessageDate', direction: 'Descending' }] },
			filterOptions: {
				type: "Menu"
			},
			selectionOptions: {
				type: "Single"
			},

			TextTemplate: function TextTemplate() {
				return {
					template: {
						extends: __WEBPACK_IMPORTED_MODULE_4__components_Systems_ProbablyOverflowingTextCell__["a" /* default */]
					}
				};
			}
		};
	},

	computed: {
		isMobile: function isMobile() {
			return this.$store.getters.isMobile;
		},
		toolbar: function toolbar() {
			return [{ text: this.$t('AddTicket'), tooltipText: this.$t('AddTicket'), prefixIcon: 'e-add', id: 'add-ticket', align: 'Left' }, { text: this.$t(this.mode == 'Active' ? 'ShowAllTickets' : 'ShowActiveTickets'), id: 'toggle-mode', align: 'Left' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Left' }, 'Search'];
		}
	},
	methods: {
		getData: function getData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var response;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_79" /* getSystemTickets */])(_this.systemId, _this.mode);

							case 2:
								response = _context.sent;


								_this.tickets = response.map(function (t) {
									return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, t, {
										// Daty z API są w UTC bez strefy — bez przeliczenia grid pokazywał je przesunięte o offset.
										createDate: Object(__WEBPACK_IMPORTED_MODULE_7__components_Systems_Tickets_ticketChat__["g" /* parseUtc */])(t.createDate),
										lastMessageDate: Object(__WEBPACK_IMPORTED_MODULE_7__components_Systems_Tickets_ticketChat__["g" /* parseUtc */])(t.lastMessageDate || t.createDate),
										statusLabel: __WEBPACK_IMPORTED_MODULE_7__components_Systems_Tickets_ticketChat__["b" /* STATUS_KEYS */][t.status] ? _this.$t(__WEBPACK_IMPORTED_MODULE_7__components_Systems_Tickets_ticketChat__["b" /* STATUS_KEYS */][t.status]) : ''
									});
								});

								// Zaznaczone zgłoszenie po przeładowaniu (np. po zamknięciu) podmieniamy na świeży wiersz.
								// Jeśli wypadło z filtra „Aktywne”, czat zostaje otwarty ze stanem „zamknięte”.
								if (_this.selectedTicket != null) {
									_this.selectedTicket = _this.tickets.find(function (t) {
										return t.id == _this.selectedTicket.id;
									}) || _this.selectedTicket;
								}

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},

		toolbarClick: function toolbarClick(args) {
			switch (args.item.id) {
				case 'clear-filters':
					this.$refs.grid.clearFiltering();
					break;
				case "add-ticket":
					this.activeModal = "ADD_TICKET";
					break;
				case "toggle-mode":
					this.mode = this.mode == 'Active' ? 'All' : 'Active';
					this.getData();
					break;
			}
		},
		rowDataBound: function rowDataBound(args) {
			// Klasa zamiast stylu inline — inline przebijał nakładkę ciemnego motywu
			// i wiersz zostawał jasny pod jasnym tekstem. Kolor siedzi w theme.css.
			// IsRead z API = wszystkie wiadomości przeczytane, więc wyróżniamy zgłoszenia z nieprzeczytanymi.
			args.row.classList.toggle('unread-ticket', !args.data["isRead"]);
		},

		dataBound: function dataBound() {
			// Temat bez autodopasowania: to szablon komórki i autoFit liczył mu szerokość 0.
			this.$refs.grid.autoFitColumns(['lastMessageDate', 'statusLabel', 'assigneeName', 'lastMessageFrom', 'createDate']);

			if (this.selectedTicket != null) {
				var index = this.$refs.grid.getRowIndexByPrimaryKey(this.selectedTicket.id);
				if (index >= 0) this.$refs.grid.selectRow(index);
			}
		},
		selectionChanged: function selectionChanged() {
			var selection = this.$refs.grid.getSelectedRecords();

			if (selection.length == 0 || selection.length > 1) return;

			this.selectedTicket = selection[0];
		},
		markRead: function markRead(ticketId) {
			// Lokalnie, bez przeładowania listy (i bez gubienia przewinięcia/zaznaczenia).
			var ticket = this.tickets.find(function (t) {
				return t.id == ticketId;
			});
			if (ticket) ticket.isRead = true;

			var index = this.$refs.grid.getRowIndexByPrimaryKey(ticketId);
			var row = index >= 0 ? this.$refs.grid.getRowByIndex(index) : null;
			if (row) row.classList.remove('unread-ticket');
		},
		clearSelection: function clearSelection() {
			this.selectedTicket = null;
			this.$refs.grid.clearSelection();
		},
		closeModal: function closeModal() {
			this.activeModal = 'NONE';
			this.getData();
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return _this2.getData();

						case 2:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	}
});

/***/ }),

/***/ 1886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ticketChat__ = __webpack_require__(1799);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__["a" /* default */],
        Button: __WEBPACK_IMPORTED_MODULE_7__Button_vue__["a" /* default */]
    },
    data: function data() {
        return {
            ticketInfo: {
                systemId: '',
                subject: '',
                content: '',
                assignedFarmerId: ''
            },
            error: '',
            systemUserNames: [],
            photos: [],
            saving: false
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api__["_81" /* getSystemUsersNames */])(_this.systemId);

                            case 2:
                                _this.systemUserNames = _context.sent;


                                if (_this.systemUserNames.length == 1) {
                                    _this.ticketInfo.assignedFarmerId = _this.systemUserNames[0].id;
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var toSend, form, keys, i, photosSrc, _i;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!_this2.saving) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:

                                _this2.checkDataCorrectness();

                                if (!(_this2.error != "")) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:

                                _this2.ticketInfo.systemId = _this2.systemId;
                                toSend = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this2.ticketInfo);
                                form = new FormData();
                                keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(toSend);

                                for (i = 0; i < keys.length; i++) {
                                    form.append(keys[i], toSend[keys[i]]);
                                }

                                photosSrc = _this2.photos.map(function (x) {
                                    return x.src;
                                });

                                for (_i = 0; _i < photosSrc.length; _i++) {
                                    form.append("resources", photosSrc[_i]);
                                }
                                // Blokada na czas wysyłki — zdjęcia idą kilka sekund, a drugi klik tworzył drugie zgłoszenie.
                                _this2.saving = true;
                                _context2.prev = 13;
                                _context2.next = 16;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api__["_103" /* postNewTicket */])(form);

                            case 16:
                                _context2.next = 22;
                                break;

                            case 18:
                                _context2.prev = 18;
                                _context2.t0 = _context2['catch'](13);

                                _this2.error = _this2.$i18n.t(Object(__WEBPACK_IMPORTED_MODULE_8__ticketChat__["h" /* sendErrorKey */])(_context2.t0, photosSrc.length > 0));
                                return _context2.abrupt('return');

                            case 22:
                                _context2.prev = 22;

                                _this2.saving = false;
                                return _context2.finish(22);

                            case 25:
                                _this2.$emit('saved');

                            case 26:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[13, 18, 22, 25]]);
            }))();
        },
        checkDataCorrectness: function checkDataCorrectness() {
            this.error = "";

            if (this.ticketInfo.assignedFarmerId == '') {
                this.error = this.$i18n.t("AssigneeNotSelected");
                return;
            }

            if (this.ticketInfo.subject == '') {
                this.error = this.$i18n.t("SubjectNotFilled");
                return;
            }

            if (this.ticketInfo.content == '') {
                this.error = this.$i18n.t("ContentNotFilled");
                return;
            }
        },
        sortSystemsByName: function sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        },
        addPhoto: function addPhoto(e) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(e.target.files).filter(function (f) {
                return f.type != null && f.type.startsWith('image/');
            }).forEach(function (file) {
                return _this3.photos.push({ src: file, url: URL.createObjectURL(file) });
            });
            // Ten sam plik wybrany drugi raz (np. po usunięciu) też ma wywołać change.
            e.target.value = '';
        },
        deletePhoto: function deletePhoto(index) {
            URL.revokeObjectURL(this.photos[index].url);
            this.photos.splice(index, 1);
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.photos.forEach(function (p) {
            return URL.revokeObjectURL(p.url);
        });
    },
    mounted: function mounted() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _this4.getData();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }))();
    }
});

/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChatImage_vue__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChatComposer_vue__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ticketChat__ = __webpack_require__(1799);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Wiadomości są rzadkie, więc zamiast websocketów lekkie odświeżanie otwartego wątku.
var REFRESH_MS = 60 * 1000;
// Ile pikseli od dołu listy liczy się jeszcze jako „na dole” (wtedy nowe wiadomości przewijają).
var NEAR_BOTTOM_PX = 80;

var localId = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_7__components_Modal__["a" /* default */], ChatImage: __WEBPACK_IMPORTED_MODULE_8__ChatImage_vue__["a" /* default */], ChatComposer: __WEBPACK_IMPORTED_MODULE_9__ChatComposer_vue__["a" /* default */] },
    props: {
        // Wiersz z listy zgłoszeń (TicketsOverviewDto) — nagłówek jest z niego, zanim dojdzie wątek.
        ticket: { type: Object, required: true },
        showBack: { type: Boolean, default: false }
    },
    data: function data() {
        return {
            TicketStatus: __WEBPACK_IMPORTED_MODULE_10__ticketChat__["c" /* TicketStatus */],
            thread: null,
            messages: [],
            pending: [],
            // resourceId → { url, failed } — przeżywa przełączanie zgłoszeń, zwalniane w beforeDestroy.
            images: {},
            loading: false,
            error: '',
            busy: false,
            confirmingClose: false,
            dragging: false,
            viewer: null
        };
    },

    computed: {
        myUserId: function myUserId() {
            return this.$store.getters.user.userId;
        },
        canManage: function canManage() {
            // Zamykanie i akceptacja zamknięcia to endpointy Admin/Service.
            return !this.$store.getters.isUser;
        },
        status: function status() {
            return this.thread != null ? this.thread.status : this.ticket.status;
        },
        statusLabel: function statusLabel() {
            var key = __WEBPACK_IMPORTED_MODULE_10__ticketChat__["b" /* STATUS_KEYS */][this.status];
            return key ? this.$t(key) : '';
        },
        subject: function subject() {
            return this.thread != null ? this.thread.subject : this.ticket.subject;
        },
        assigneeName: function assigneeName() {
            return this.thread != null ? this.thread.assigneeName : this.ticket.assigneeName;
        },
        createDate: function createDate() {
            return Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["g" /* parseUtc */])(this.thread != null ? this.thread.createDate : this.ticket.createDate);
        },
        timeline: function timeline() {
            var _this = this;

            var pending = this.pending.filter(function (p) {
                return p.ticketId == _this.ticket.id;
            });
            return Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["d" /* buildTimeline */])(this.messages.concat(pending), this.myUserId);
        },
        viewerUrl: function viewerUrl() {
            if (this.viewer == null) return null;
            var item = this.viewer.items[this.viewer.index];
            return item.url || this.imageUrl(item.id);
        }
    },
    watch: {
        'ticket.id': function ticketId() {
            this.confirmingClose = false;
            this.viewer = null;
            this.load();
        }
    },
    mounted: function mounted() {
        this.load();
        this.refreshTimer = setInterval(this.refresh, REFRESH_MS);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('keydown', this.onKeydown);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.refreshTimer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('keydown', this.onKeydown);
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.images).forEach(function (img) {
            if (img.url) URL.revokeObjectURL(img.url);
        });
        this.pending.forEach(function (p) {
            return p.localPhotos.forEach(function (url) {
                return URL.revokeObjectURL(url);
            });
        });
    },

    methods: {
        load: function load() {
            var _this2 = this;

            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$silent = _ref.silent,
                silent = _ref$silent === undefined ? false : _ref$silent;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var ticketId, token, wasNearBottom, result, messages, knownIds, newFromOthers;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                ticketId = _this2.ticket.id;
                                // Szybkie przełączanie zgłoszeń: odpowiedź dla poprzedniego nie może nadpisać bieżącego.

                                token = _this2.loadToken = (_this2.loadToken || 0) + 1;


                                if (!silent) {
                                    _this2.loading = true;
                                    _this2.error = '';
                                    _this2.thread = null;
                                    _this2.messages = [];
                                }

                                wasNearBottom = _this2.isNearBottom();
                                _context.prev = 4;
                                _context.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api__["_34" /* getMessagesForTicket */])(ticketId);

                            case 7:
                                result = _context.sent;

                                if (!(token !== _this2.loadToken)) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 10:
                                messages = result.messages.map(function (m) {
                                    return {
                                        id: m.id,
                                        isEvent: m.isEvent,
                                        content: m.content,
                                        resources: (m.resources || []).filter(function (r) {
                                            return r != null;
                                        }),
                                        sentDate: Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["g" /* parseUtc */])(m.sentDate),
                                        creatorId: m.creatorId,
                                        creatorName: m.creatorName
                                    };
                                });
                                knownIds = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(_this2.messages.map(function (m) {
                                    return m.id;
                                }));
                                newFromOthers = messages.some(function (m) {
                                    return !knownIds.has(m.id) && m.creatorId !== _this2.myUserId;
                                });


                                _this2.thread = result;
                                _this2.messages = messages;

                                if (!silent || wasNearBottom) {
                                    _this2.$nextTick(_this2.scrollToBottom);
                                }

                                if (!silent || newFromOthers) {
                                    Object(__WEBPACK_IMPORTED_MODULE_5__api__["_105" /* readTicket */])(ticketId).then(function () {
                                        return _this2.$emit('read', ticketId);
                                    });
                                }
                                _context.next = 22;
                                break;

                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context['catch'](4);

                                if (token === _this2.loadToken && !silent) {
                                    _this2.error = _this2.$t('LoadingMessagesFailed');
                                }

                            case 22:
                                _context.prev = 22;

                                if (token === _this2.loadToken) _this2.loading = false;
                                return _context.finish(22);

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[4, 19, 22, 25]]);
            }))();
        },
        refresh: function refresh() {
            if (document.hidden || this.loading || this.status == __WEBPACK_IMPORTED_MODULE_10__ticketChat__["c" /* TicketStatus */].Closed) return;
            this.load({ silent: true });
        },
        loadImage: function loadImage(id) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var res, url;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this3.images[id] != null)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this3.$set(_this3.images, id, { url: null, failed: false });

                                _context2.prev = 3;
                                _context2.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api__["_33" /* getMessageResource */])(id);

                            case 6:
                                res = _context2.sent;
                                url = URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));

                                _this3.$set(_this3.images, id, { url: url, failed: false });
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](3);

                                _this3.$set(_this3.images, id, { url: null, failed: true });

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[3, 11]]);
            }))();
        },
        imageUrl: function imageUrl(id) {
            var img = this.images[id];
            return img ? img.url : null;
        },
        imageFailed: function imageFailed(id) {
            var img = this.images[id];
            return img ? img.failed : false;
        },
        hasImages: function hasImages(message) {
            return message.resources.length > 0 || message.localPhotos != null && message.localPhotos.length > 0;
        },
        openViewer: function openViewer(id) {
            var _this4 = this;

            var items = [];
            this.messages.forEach(function (m) {
                return m.resources.forEach(function (r) {
                    return items.push({ id: r });
                });
            });
            items.forEach(function (item) {
                return _this4.loadImage(item.id);
            });
            this.viewer = { items: items, index: Math.max(0, items.findIndex(function (i) {
                    return i.id === id;
                })) };
        },
        openLocal: function openLocal(url) {
            this.viewer = { items: [{ url: url }], index: 0 };
        },
        moveViewer: function moveViewer(step) {
            var count = this.viewer.items.length;
            this.viewer.index = (this.viewer.index + step + count) % count;
        },
        onKeydown: function onKeydown(event) {
            if (this.viewer == null || this.viewer.items.length < 2) return;
            if (event.key === 'ArrowLeft') this.moveViewer(-1);
            if (event.key === 'ArrowRight') this.moveViewer(1);
        },
        send: function send(_ref2) {
            var content = _ref2.content,
                files = _ref2.files;

            var message = {
                id: 'local-' + ++localId,
                ticketId: this.ticket.id,
                isEvent: false,
                content: content,
                resources: [],
                files: files,
                localPhotos: files.map(function (f) {
                    return URL.createObjectURL(f);
                }),
                sentDate: new Date(),
                creatorId: this.myUserId,
                creatorName: this.$store.getters.user.fullName,
                state: 'sending',
                errorKey: null
            };
            this.pending.push(message);
            this.$nextTick(this.scrollToBottom);
            this.post(message);
        },
        retry: function retry(message) {
            message.state = 'sending';
            this.post(message);
        },
        post: function post(message) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var form, key;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                form = new FormData();

                                form.append('ticketId', message.ticketId);
                                form.append('content', message.content);
                                message.files.forEach(function (f) {
                                    return form.append('resources', f);
                                });

                                _context3.prev = 4;
                                _context3.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_5__api__["_112" /* sendMessage */])(form);

                            case 7:
                                _context3.next = 15;
                                break;

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3['catch'](4);
                                key = Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["h" /* sendErrorKey */])(_context3.t0, message.files.length > 0);

                                message.errorKey = key == 'SendFailed' ? null : key;
                                message.state = 'failed';
                                return _context3.abrupt('return');

                            case 15:
                                if (!(message.ticketId == _this5.ticket.id)) {
                                    _context3.next = 18;
                                    break;
                                }

                                _context3.next = 18;
                                return _this5.load({ silent: true });

                            case 18:
                                _this5.pending = _this5.pending.filter(function (p) {
                                    return p !== message;
                                });
                                message.localPhotos.forEach(function (url) {
                                    return URL.revokeObjectURL(url);
                                });

                            case 20:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5, [[4, 9]]);
            }))();
        },
        closeTicket: function closeTicket() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this6.changeStatus(__WEBPACK_IMPORTED_MODULE_5__api__["p" /* confirmRequestToClose */]);

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        denyClose: function denyClose() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this7.changeStatus(__WEBPACK_IMPORTED_MODULE_5__api__["F" /* denyRequestToClose */]);

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7);
            }))();
        },
        changeStatus: function changeStatus(action) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this8.busy = true;
                                _context6.prev = 1;
                                _context6.next = 4;
                                return action(_this8.ticket.id);

                            case 4:
                                _this8.confirmingClose = false;
                                _context6.next = 7;
                                return _this8.load({ silent: true });

                            case 7:
                                _this8.$emit('changed', _this8.ticket.id);

                            case 8:
                                _context6.prev = 8;

                                _this8.busy = false;
                                return _context6.finish(8);

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8, [[1,, 8, 11]]);
            }))();
        },
        onDragOver: function onDragOver(event) {
            if (this.status == __WEBPACK_IMPORTED_MODULE_10__ticketChat__["c" /* TicketStatus */].Closed) return;
            var types = event.dataTransfer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(event.dataTransfer.types) : [];
            this.dragging = types.includes('Files');
        },
        onDragLeave: function onDragLeave(event) {
            // dragleave przychodzi też przy wejściu nad dziecko — liczy się tylko wyjście z panelu.
            if (!this.$el.contains(event.relatedTarget)) this.dragging = false;
        },
        onDrop: function onDrop(event) {
            this.dragging = false;
            if (this.$refs.composer && event.dataTransfer) {
                this.$refs.composer.addFiles(event.dataTransfer.files);
                this.$refs.composer.focus();
            }
        },
        isNearBottom: function isNearBottom() {
            var list = this.$refs.list;
            return list == null || list.scrollHeight - list.scrollTop - list.clientHeight < NEAR_BOTTOM_PX;
        },
        scrollToBottom: function scrollToBottom() {
            var list = this.$refs.list;
            if (list) list.scrollTop = list.scrollHeight;
        },
        eventText: function eventText(message) {
            var key = __WEBPACK_IMPORTED_MODULE_10__ticketChat__["a" /* EVENT_KEYS */][message.content];
            return key ? this.$t(key) : message.content;
        },

        initials: __WEBPACK_IMPORTED_MODULE_10__ticketChat__["f" /* initials */],
        dayLabel: function dayLabel(date) {
            var today = new Date();
            var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            if (Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["e" /* dayKey */])(date) === Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["e" /* dayKey */])(today)) return this.$t('Today');
            if (Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["e" /* dayKey */])(date) === Object(__WEBPACK_IMPORTED_MODULE_10__ticketChat__["e" /* dayKey */])(yesterday)) return this.$t('Yesterday');
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYY-MM-DD');
        },
        formatTime: function formatTime(date) {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('HH:mm');
        },
        formatDay: function formatDay(date) {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYY-MM-DD');
        },
        formatFull: function formatFull(date) {
            return date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYY-MM-DD HH:mm') : '';
        }
    }
});

/***/ }),

/***/ 1888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

// Kafelek zdjęcia w dymku. Stały rozmiar od razu (brak skakania przewijania),
// a o pobranie prosi dopiero, gdy wjedzie w widoczny obszar listy.
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        src: { type: String, default: null },
        failed: { type: Boolean, default: false }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.src) return;

        if (typeof IntersectionObserver === 'undefined') {
            this.$emit('visible');
            return;
        }

        this.observer = new IntersectionObserver(function (entries) {
            if (entries.some(function (e) {
                return e.isIntersecting;
            })) {
                _this.$emit('visible');
                _this.disconnect();
            }
        }, { rootMargin: '200px' });
        this.observer.observe(this.$el);
    },
    beforeDestroy: function beforeDestroy() {
        this.disconnect();
    },

    methods: {
        disconnect: function disconnect() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        }
    }
});

/***/ }),

/***/ 1889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Pole do pisania: rośnie z treścią do kilku linii, Enter wysyła, Shift+Enter łamie linię.
// Zdjęcia z przycisku, ze schowka albo przeciągnięte na panel (addFiles z rodzica).
var MAX_HEIGHT = 140;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            text: '',
            attachments: []
        };
    },

    computed: {
        canSend: function canSend() {
            // Treść wymagana jak dotąd — pusta wiadomość ze zdjęciem trafiłaby do bazy jako null.
            return this.text.trim() !== '';
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.attachments.forEach(function (a) {
            return URL.revokeObjectURL(a.url);
        });
    },

    methods: {
        onEnter: function onEnter(event) {
            // isComposing: Enter zatwierdzający znak w IME nie wysyła wiadomości.
            if (event.shiftKey || event.isComposing) return;
            event.preventDefault();
            this.submit();
        },
        submit: function submit() {
            if (!this.canSend) return;

            this.$emit('send', {
                content: this.text.trim(),
                files: this.attachments.map(function (a) {
                    return a.file;
                })
            });

            this.attachments.forEach(function (a) {
                return URL.revokeObjectURL(a.url);
            });
            this.attachments = [];
            this.text = '';
            this.$nextTick(this.autoGrow);
        },
        addFiles: function addFiles(files) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(files).filter(function (f) {
                return f.type != null && f.type.startsWith('image/');
            }).forEach(function (file) {
                return _this.attachments.push({ file: file, url: URL.createObjectURL(file) });
            });
        },
        onFileChange: function onFileChange(event) {
            this.addFiles(event.target.files);
            // Ten sam plik wybrany drugi raz też ma wywołać change.
            event.target.value = '';
        },
        onPaste: function onPaste(event) {
            var files = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(event.clipboardData && event.clipboardData.files || []);
            if (files.some(function (f) {
                return f.type.startsWith('image/');
            })) {
                event.preventDefault();
                this.addFiles(files);
            }
        },
        removeAttachment: function removeAttachment(index) {
            URL.revokeObjectURL(this.attachments[index].url);
            this.attachments.splice(index, 1);
        },
        autoGrow: function autoGrow() {
            var input = this.$refs.input;
            if (!input) return;
            input.style.height = 'auto';
            input.style.height = Math.min(input.scrollHeight, MAX_HEIGHT) + 'px';
        },
        focus: function focus() {
            if (this.$refs.input) this.$refs.input.focus();
        }
    }
});

/***/ }),

/***/ 2285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("522f87fa", content, true, {});

/***/ }),

/***/ 2286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tickets-layout{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;gap:10px}.tickets-layout__grid{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;height:100%}.tickets-layout__chat{-webkit-box-flex:0;-ms-flex:0 0 38%;flex:0 0 38%;min-width:360px;height:100%;overflow:hidden}.tickets-layout--mobile .tickets-layout__chat{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.messages-area{background:var(--messages-panel-bg);border:1px solid var(--messages-panel-border);border-radius:5px}.messages-area__empty{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;color:var(--chat-muted)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemFarmerTickets.vue"],"names":[],"mappings":"AACA,gBACC,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,QAAU,CACV,AACD,sBACC,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,WAAa,CACb,AACD,sBACC,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,gBAAiB,AACjB,YAAa,AACb,eAAiB,CACjB,AACD,8CACC,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,WAAa,CACb,AACD,eACI,oCAAqC,AACrC,8CAA+C,AAC/C,iBAAmB,CACtB,AACD,sBACC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,YAAa,AACb,uBAAyB,CACzB","file":"SystemFarmerTickets.vue","sourcesContent":["\n.tickets-layout {\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\tgap: 10px;\n}\n.tickets-layout__grid {\n\t-webkit-box-flex: 1;\n\t    -ms-flex: 1;\n\t        flex: 1;\n\tmin-width: 0;\n\theight: 100%;\n}\n.tickets-layout__chat {\n\t-webkit-box-flex: 0;\n\t    -ms-flex: 0 0 38%;\n\t        flex: 0 0 38%;\n\tmin-width: 360px;\n\theight: 100%;\n\toverflow: hidden;\n}\n.tickets-layout--mobile .tickets-layout__chat {\n\t-webkit-box-flex: 1;\n\t    -ms-flex: 1;\n\t        flex: 1;\n\tmin-width: 0;\n}\n.messages-area {\n    background: var(--messages-panel-bg);\n    border: 1px solid var(--messages-panel-border);\n    border-radius: 5px;\n}\n.messages-area__empty {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\theight: 100%;\n\tcolor: var(--chat-muted);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketModal_vue__ = __webpack_require__(1886);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0688ef6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketModal_vue__ = __webpack_require__(2292);
function injectStyle (ssrContext) {
  __webpack_require__(2288)
  __webpack_require__(2290)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0688ef6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0688ef6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2288:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2289);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("e3f17da8", content, true, {});

/***/ }),

/***/ 2289:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".gallery-container[data-v-b0688ef6]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.section-title[data-v-b0688ef6]{text-align:center}.info-field[data-v-b0688ef6]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.info-field-title[data-v-b0688ef6]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-b0688ef6]{-ms-flex-item-align:center;align-self:center;width:80%;margin:0;padding-bottom:5px}.section-title[data-v-b0688ef6]{font-weight:700}select[data-v-b0688ef6],textarea[data-v-b0688ef6]{width:210px;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}textarea[data-v-b0688ef6]{height:200px;max-height:300px}.info-field-row>td[data-v-b0688ef6]{vertical-align:middle}.error[data-v-b0688ef6]{font-size:14px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/Tickets/TicketModal.vue"],"names":[],"mappings":"AACA,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,gCAEI,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,2BAA4B,AACxB,kBAAmB,AACvB,UAAW,AACX,SAAU,AACV,kBAAoB,CACvB,AACD,gCACI,eAAkB,CACrB,AAQD,kDANI,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAU/C,AARD,0BACI,aAAc,AACd,gBAAkB,CAMrB,AACD,oCACI,qBAAuB,CAC1B,AACD,wBACI,cAAgB,CACnB","file":"TicketModal.vue","sourcesContent":["\n.gallery-container[data-v-b0688ef6] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.section-title[data-v-b0688ef6] {\n    font-weight: bold;\n    text-align: center;\n}\n.info-field[data-v-b0688ef6] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.info-field-title[data-v-b0688ef6] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-b0688ef6] {\n    -ms-flex-item-align: center;\n        align-self: center;\n    width: 80%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.section-title[data-v-b0688ef6] {\n    font-weight: bold;\n}\nselect[data-v-b0688ef6] {\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\ntextarea[data-v-b0688ef6] {\n    height: 200px;\n    max-height: 300px;\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\n.info-field-row > td[data-v-b0688ef6] {\n    vertical-align: middle;\n}\n.error[data-v-b0688ef6] {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2290:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2291);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1051f60b", content, true, {});

/***/ }),

/***/ 2291:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".info-field-value[data-v-b0688ef6]{width:100%}.ticket-photos[data-v-b0688ef6]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;padding:4px 0 10px}.ticket-photos__item[data-v-b0688ef6]{position:relative;width:72px;height:72px}.ticket-photos__item img[data-v-b0688ef6]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:6px}.ticket-photos__remove[data-v-b0688ef6]{position:absolute;top:-6px;right:-6px;width:20px;height:20px;border:none;border-radius:50%;background:var(--danger);color:#fff;line-height:18px;font-size:14px;padding:0;cursor:pointer}.ticket-photos__add[data-v-b0688ef6]{width:72px;height:72px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:2px;border:1px dashed var(--input-border);border-radius:6px;background:transparent;color:var(--text-muted);font-size:11px;line-height:13px;text-align:center;cursor:pointer}.ticket-photos__add[data-v-b0688ef6]:hover{border-color:var(--accent);color:var(--accent)}.ticket-photos__file[data-v-b0688ef6]{display:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/Tickets/TicketModal.vue"],"names":[],"mappings":"AACA,mCACI,UAAY,CACf,AACD,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,kBAAoB,CACvB,AACD,sCACI,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAChB,AACD,0CACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,iBAAmB,CACtB,AACD,wCACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,UAAW,AACX,cAAgB,CACnB,AACD,qCACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,QAAS,AACT,sCAAuC,AACvC,kBAAmB,AACnB,uBAAwB,AACxB,wBAAyB,AACzB,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,cAAgB,CACnB,AACD,2CACI,2BAA4B,AAC5B,mBAAqB,CACxB,AACD,sCACI,YAAc,CACjB","file":"TicketModal.vue","sourcesContent":["\n.info-field-value[data-v-b0688ef6] {\n    width: 100%;\n}\n.ticket-photos[data-v-b0688ef6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 8px;\n    padding: 4px 0 10px;\n}\n.ticket-photos__item[data-v-b0688ef6] {\n    position: relative;\n    width: 72px;\n    height: 72px;\n}\n.ticket-photos__item img[data-v-b0688ef6] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 6px;\n}\n.ticket-photos__remove[data-v-b0688ef6] {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    width: 20px;\n    height: 20px;\n    border: none;\n    border-radius: 50%;\n    background: var(--danger);\n    color: #fff;\n    line-height: 18px;\n    font-size: 14px;\n    padding: 0;\n    cursor: pointer;\n}\n.ticket-photos__add[data-v-b0688ef6] {\n    width: 72px;\n    height: 72px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 2px;\n    border: 1px dashed var(--input-border);\n    border-radius: 6px;\n    background: transparent;\n    color: var(--text-muted);\n    font-size: 11px;\n    line-height: 13px;\n    text-align: center;\n    cursor: pointer;\n}\n.ticket-photos__add[data-v-b0688ef6]:hover {\n    border-color: var(--accent);\n    color: var(--accent);\n}\n.ticket-photos__file[data-v-b0688ef6] {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical grow gallery-container",staticStyle:{"width":"35vw","height":"100%"}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('MainAssignee')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketInfo.assignedFarmerId),expression:"ticketInfo.assignedFarmerId"}],staticStyle:{"width":"100%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ticketInfo, "assignedFarmerId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.systemUserNames),function(n){return _c('option',{key:n.id,domProps:{"value":n.id}},[_vm._v("\n                                  "+_vm._s(n.name)+"\n                              ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Subject')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketInfo.subject),expression:"ticketInfo.subject"}],staticStyle:{"height":"50px","width":"100%"},attrs:{"type":"text","placeholder":_vm.$t('Subject')},domProps:{"value":(_vm.ticketInfo.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ticketInfo, "subject", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Content')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketInfo.content),expression:"ticketInfo.content"}],staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":_vm.$t('Content')},domProps:{"value":(_vm.ticketInfo.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ticketInfo, "content", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Photos')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('div',{staticClass:"ticket-photos"},[_vm._l((_vm.photos),function(photo,index){return _c('div',{key:photo.url,staticClass:"ticket-photos__item"},[_c('img',{attrs:{"src":photo.url,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"ticket-photos__remove",attrs:{"type":"button","title":_vm.$t('Remove')},on:{"click":function($event){return _vm.deletePhoto(index)}}},[_vm._v("×")])])}),_vm._v(" "),_c('button',{staticClass:"ticket-photos__add",attrs:{"type":"button","title":_vm.$t('AddPhotos')},on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 5v14M5 12h14"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('AddPhotos')))])])],2),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"ticket-photos__file",attrs:{"type":"file","id":"problemPhotoId","name":"problemPhoto","accept":"image/*","multiple":""},on:{"change":_vm.addPhoto}})])])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center","margin-bottom":"10px"}},[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center","margin-bottom":"20px"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t(_vm.saving ? 'Sending' : 'Save'),"buttonClass":"save-button semi-bold","disabled":_vm.saving},on:{"onClick":_vm.save}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketChat_vue__ = __webpack_require__(1887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395ac1a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketChat_vue__ = __webpack_require__(2308);
function injectStyle (ssrContext) {
  __webpack_require__(2294)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395ac1a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395ac1a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2294:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1f7edea4", content, true, {});

/***/ }),

/***/ 2295:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".ticket-chat[data-v-395ac1a0]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;min-height:0;background:var(--messages-panel-bg);color:var(--text)}.ticket-chat__header[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding:10px 14px;border-bottom:1px solid var(--messages-panel-border);background:var(--chat-header-bg)}.ticket-chat__back[data-v-395ac1a0]{border:none;background:transparent;color:var(--text);padding:4px;border-radius:50%;cursor:pointer}.ticket-chat__title[data-v-395ac1a0]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.ticket-chat__subject[data-v-395ac1a0]{font-weight:600;font-size:15px;color:var(--text-strong);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ticket-chat__meta[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;font-size:12px;color:var(--chat-muted);margin-top:2px}.ticket-chat__status[data-v-395ac1a0]{padding:1px 8px;border-radius:10px;font-weight:600;background:var(--chat-status-bg);color:var(--chat-status-fg)}.ticket-chat__status--0[data-v-395ac1a0],.ticket-chat__status--2[data-v-395ac1a0]{background:var(--status-warning-tint)}.ticket-chat__status--3[data-v-395ac1a0]{background:var(--status-error-tint)}.ticket-chat__status--4[data-v-395ac1a0]{background:var(--status-down-tint)}.ticket-chat__actions[data-v-395ac1a0],.ticket-chat__banner-actions[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;-ms-flex-negative:0;flex-shrink:0}.ticket-chat__confirm[data-v-395ac1a0]{font-size:13px}.ticket-chat__action[data-v-395ac1a0]{border:1px solid var(--input-border);background:var(--surface);color:var(--text);border-radius:6px;padding:4px 12px;font-size:13px;cursor:pointer}.ticket-chat__action[data-v-395ac1a0]:hover{background:var(--surface-hover-solid)}.ticket-chat__action[data-v-395ac1a0]:disabled{opacity:.5;cursor:default}.ticket-chat__action--primary[data-v-395ac1a0]{background:var(--chat-bubble-mine-bg);border-color:var(--chat-bubble-mine-bg);color:var(--chat-bubble-mine-fg)}.ticket-chat__action--primary[data-v-395ac1a0]:hover{background:var(--chat-bubble-mine-bg);-webkit-filter:brightness(1.1);filter:brightness(1.1)}.ticket-chat__action--danger[data-v-395ac1a0]{background:var(--danger);border-color:var(--danger);color:#fff}.ticket-chat__action--danger[data-v-395ac1a0]:hover{background:var(--danger);-webkit-filter:brightness(1.1);filter:brightness(1.1)}.ticket-chat__list[data-v-395ac1a0]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:0;overflow-y:auto;padding:12px 14px}.ticket-chat__day[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:14px 0 6px}.ticket-chat__day span[data-v-395ac1a0],.ticket-chat__event span[data-v-395ac1a0]{font-size:12px;color:var(--chat-muted);background:var(--chat-event-bg);padding:2px 10px;border-radius:10px}.ticket-chat__event[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:8px 0}.ticket-chat__event span[data-v-395ac1a0]{font-style:italic}.ticket-chat__notice[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;margin-top:40px;color:var(--chat-muted);text-align:center}.ticket-chat__skeleton-bubble[data-v-395ac1a0]{height:44px;width:55%;margin:10px 0;border-radius:14px;background:var(--skeleton)}.ticket-chat__skeleton-bubble--mine[data-v-395ac1a0]{margin-left:auto;width:40%}.chat-row[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;gap:8px;margin-top:2px}.chat-row--start[data-v-395ac1a0]{margin-top:10px}.chat-row--mine[data-v-395ac1a0]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.chat-avatar[data-v-395ac1a0]{-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;border-radius:50%;background:var(--chat-avatar-bg);color:var(--chat-avatar-fg);font-size:12px;font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-item-align:start;align-self:flex-start;margin-top:18px}.chat-avatar--hidden[data-v-395ac1a0]{visibility:hidden;height:0;margin-top:0}.chat-column[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:78%;min-width:0}.chat-row--mine .chat-column[data-v-395ac1a0]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.chat-author[data-v-395ac1a0]{font-size:12px;color:var(--chat-muted);margin:0 0 2px 4px}.chat-bubble[data-v-395ac1a0]{padding:7px 12px;border-radius:6px 16px 16px 6px;background:var(--chat-bubble-bg);color:var(--chat-bubble-fg);font-size:14px;line-height:1.4}.chat-bubble--start[data-v-395ac1a0]{border-top-left-radius:16px}.chat-bubble--end[data-v-395ac1a0]{border-bottom-left-radius:16px}.chat-bubble--mine[data-v-395ac1a0]{border-radius:16px 6px 6px 16px;background:var(--chat-bubble-mine-bg);color:var(--chat-bubble-mine-fg)}.chat-bubble--mine.chat-bubble--start[data-v-395ac1a0]{border-top-right-radius:16px}.chat-bubble--mine.chat-bubble--end[data-v-395ac1a0]{border-bottom-right-radius:16px}.chat-bubble--pending[data-v-395ac1a0]{opacity:.6}.chat-bubble--failed[data-v-395ac1a0]{outline:2px solid var(--danger)}.chat-bubble__text[data-v-395ac1a0]{white-space:pre-wrap;overflow-wrap:anywhere}.chat-bubble__images[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:4px;margin:4px -6px -2px}.chat-bubble__text+.chat-bubble__images[data-v-395ac1a0]{margin-top:8px}.chat-time[data-v-395ac1a0]{font-size:11px;color:var(--chat-muted);margin:2px 4px 0}.chat-time--failed[data-v-395ac1a0]{color:var(--danger)}.chat-retry[data-v-395ac1a0]{border:none;background:transparent;color:var(--accent);text-decoration:underline;padding:0 0 0 4px;font-size:11px;cursor:pointer}.ticket-chat__banner[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;padding:10px 14px;background:var(--status-warning-tint);border-top:1px solid var(--messages-panel-border);font-size:14px;font-weight:600}.ticket-chat__closed[data-v-395ac1a0]{padding:12px;text-align:center;font-size:13px;color:var(--chat-muted);border-top:1px solid var(--messages-panel-border)}.ticket-chat__drop[data-v-395ac1a0]{position:absolute;inset:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:var(--chat-drop-bg);border:2px dashed var(--accent);border-radius:5px;color:var(--text-strong);font-weight:600;pointer-events:none}.chat-viewer[data-v-395ac1a0],.ticket-chat__drop[data-v-395ac1a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.chat-viewer[data-v-395ac1a0]{position:relative;gap:10px;margin-top:5px}.chat-viewer__img[data-v-395ac1a0]{max-width:70vw;max-height:70vh}.chat-viewer__placeholder[data-v-395ac1a0]{width:40vw;height:50vh;background:var(--skeleton)}.chat-viewer__nav[data-v-395ac1a0]{border:none;background:var(--surface-hover);color:var(--text);width:36px;height:36px;border-radius:50%;font-size:22px;line-height:1;cursor:pointer}.chat-viewer__counter[data-v-395ac1a0]{position:absolute;bottom:-24px;left:0;right:0;text-align:center;font-size:12px;color:var(--chat-muted)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/Tickets/TicketChat.vue"],"names":[],"mappings":"AACA,8BACI,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,YAAa,AACb,aAAc,AACd,oCAAqC,AACrC,iBAAmB,CACtB,AAGD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,kBAAmB,AACnB,qDAAsD,AACtD,gCAAkC,CACrC,AACD,oCACI,YAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,YAAa,AACb,kBAAmB,AACnB,cAAgB,CACnB,AACD,qCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,WAAa,CAChB,AACD,uCACI,gBAAiB,AACjB,eAAgB,AAChB,yBAA0B,AAC1B,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,eAAgB,AAChB,wBAAyB,AACzB,cAAgB,CACnB,AACD,sCACI,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,iCAAkC,AAClC,2BAA6B,CAChC,AAGD,kFAA2C,qCAAuC,CACjF,AACD,yCAA2C,mCAAqC,CAC/E,AACD,yCAA2C,kCAAoC,CAC9E,AACD,qFAEI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,QAAS,AACT,oBAAqB,AACjB,aAAe,CACtB,AACD,uCACI,cAAgB,CACnB,AACD,sCACI,qCAAsC,AACtC,0BAA2B,AAC3B,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,cAAgB,CACnB,AACD,4CACI,qCAAuC,CAC1C,AACD,+CACI,WAAa,AACb,cAAgB,CACnB,AACD,+CACI,sCAAuC,AACvC,wCAAyC,AACzC,gCAAkC,CACrC,AACD,qDACI,sCAAuC,AACvC,+BAAgC,AACxB,sBAAwB,CACnC,AACD,8CACI,yBAA0B,AAC1B,2BAA4B,AAC5B,UAAY,CACf,AACD,oDACI,yBAA0B,AAC1B,+BAAgC,AACxB,sBAAwB,CACnC,AAGD,oCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,aAAc,AACd,gBAAiB,AACjB,iBAAmB,CACtB,AACD,mCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACtB,AACD,kFAEI,eAAgB,AAChB,wBAAyB,AACzB,gCAAiC,AACjC,iBAAkB,AAClB,kBAAoB,CACvB,AACD,qCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,YAAc,CACjB,AACD,0CACI,iBAAmB,CACtB,AACD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,gBAAiB,AACjB,wBAAyB,AACzB,iBAAmB,CACtB,AACD,+CACI,YAAa,AACb,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,0BAA4B,CAC/B,AACD,qDACI,iBAAkB,AAClB,SAAW,CACd,AAGD,2BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,QAAS,AACT,cAAgB,CACnB,AACD,kCACI,eAAiB,CACpB,AACD,iCACI,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACrC,AACD,8BACI,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,YAAa,AACb,kBAAmB,AACnB,iCAAkC,AAClC,4BAA6B,AAC7B,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,0BAA2B,AACvB,sBAAuB,AAC3B,eAAiB,CACpB,AACD,sCACI,kBAAmB,AACnB,SAAU,AACV,YAAc,CACjB,AACD,8BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,cAAe,AACf,WAAa,CAChB,AACD,8CACI,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACjC,AACD,8BACI,eAAgB,AAChB,wBAAyB,AACzB,kBAAoB,CACvB,AACD,8BACI,iBAAkB,AAClB,gCAAiC,AACjC,iCAAkC,AAClC,4BAA6B,AAC7B,eAAgB,AAChB,eAAiB,CACpB,AACD,qCAAuC,2BAA6B,CACnE,AACD,mCAAqC,8BAAgC,CACpE,AACD,oCACI,gCAAiC,AACjC,sCAAuC,AACvC,gCAAkC,CACrC,AACD,uDAAyD,4BAA8B,CACtF,AACD,qDAAuD,+BAAiC,CACvF,AACD,uCACI,UAAa,CAChB,AACD,sCACI,+BAAiC,CACpC,AACD,oCACI,qBAAsB,AACtB,sBAAwB,CAC3B,AACD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,oBAAsB,CACzB,AACD,yDACI,cAAgB,CACnB,AACD,4BACI,eAAgB,AAChB,wBAAyB,AACzB,gBAAkB,CACrB,AACD,oCACI,mBAAqB,CACxB,AACD,6BACI,YAAa,AACb,uBAAwB,AACxB,oBAAqB,AACrB,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,cAAgB,CACnB,AAGD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,kBAAmB,AACnB,sCAAuC,AACvC,kDAAmD,AACnD,eAAgB,AAChB,eAAiB,CACpB,AACD,sCACI,aAAc,AACd,kBAAmB,AACnB,eAAgB,AAChB,wBAAyB,AACzB,iDAAmD,CACtD,AACD,oCACI,kBAAmB,AACnB,QAAS,AAOT,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,+BAAgC,AAChC,gCAAiC,AACjC,kBAAmB,AACnB,yBAA0B,AAC1B,gBAAiB,AACjB,mBAAqB,CACxB,AAGD,kEAlBI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAuB/B,AAVD,8BACI,kBAAmB,AAOnB,SAAU,AACV,cAAgB,CACnB,AACD,mCACI,eAAgB,AAChB,eAAiB,CACpB,AACD,2CACI,WAAY,AACZ,YAAa,AACb,0BAA4B,CAC/B,AACD,mCACI,YAAa,AACb,gCAAiC,AACjC,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,cAAgB,CACnB,AACD,uCACI,kBAAmB,AACnB,aAAc,AACd,OAAQ,AACR,QAAS,AACT,kBAAmB,AACnB,eAAgB,AAChB,uBAAyB,CAC5B","file":"TicketChat.vue","sourcesContent":["\n.ticket-chat[data-v-395ac1a0] {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    background: var(--messages-panel-bg);\n    color: var(--text);\n}\n\n/* --- Nagłówek --- */\n.ticket-chat__header[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--messages-panel-border);\n    background: var(--chat-header-bg);\n}\n.ticket-chat__back[data-v-395ac1a0] {\n    border: none;\n    background: transparent;\n    color: var(--text);\n    padding: 4px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n.ticket-chat__title[data-v-395ac1a0] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n}\n.ticket-chat__subject[data-v-395ac1a0] {\n    font-weight: 600;\n    font-size: 15px;\n    color: var(--text-strong);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.ticket-chat__meta[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: var(--chat-muted);\n    margin-top: 2px;\n}\n.ticket-chat__status[data-v-395ac1a0] {\n    padding: 1px 8px;\n    border-radius: 10px;\n    font-weight: 600;\n    background: var(--chat-status-bg);\n    color: var(--chat-status-fg);\n}\n.ticket-chat__status--0[data-v-395ac1a0] { background: var(--status-warning-tint);\n}\n.ticket-chat__status--2[data-v-395ac1a0] { background: var(--status-warning-tint);\n}\n.ticket-chat__status--3[data-v-395ac1a0] { background: var(--status-error-tint);\n}\n.ticket-chat__status--4[data-v-395ac1a0] { background: var(--status-down-tint);\n}\n.ticket-chat__actions[data-v-395ac1a0],\n.ticket-chat__banner-actions[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 6px;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n.ticket-chat__confirm[data-v-395ac1a0] {\n    font-size: 13px;\n}\n.ticket-chat__action[data-v-395ac1a0] {\n    border: 1px solid var(--input-border);\n    background: var(--surface);\n    color: var(--text);\n    border-radius: 6px;\n    padding: 4px 12px;\n    font-size: 13px;\n    cursor: pointer;\n}\n.ticket-chat__action[data-v-395ac1a0]:hover {\n    background: var(--surface-hover-solid);\n}\n.ticket-chat__action[data-v-395ac1a0]:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n.ticket-chat__action--primary[data-v-395ac1a0] {\n    background: var(--chat-bubble-mine-bg);\n    border-color: var(--chat-bubble-mine-bg);\n    color: var(--chat-bubble-mine-fg);\n}\n.ticket-chat__action--primary[data-v-395ac1a0]:hover {\n    background: var(--chat-bubble-mine-bg);\n    -webkit-filter: brightness(1.1);\n            filter: brightness(1.1);\n}\n.ticket-chat__action--danger[data-v-395ac1a0] {\n    background: var(--danger);\n    border-color: var(--danger);\n    color: #fff;\n}\n.ticket-chat__action--danger[data-v-395ac1a0]:hover {\n    background: var(--danger);\n    -webkit-filter: brightness(1.1);\n            filter: brightness(1.1);\n}\n\n/* --- Lista --- */\n.ticket-chat__list[data-v-395ac1a0] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 12px 14px;\n}\n.ticket-chat__day[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 14px 0 6px;\n}\n.ticket-chat__day span[data-v-395ac1a0],\n.ticket-chat__event span[data-v-395ac1a0] {\n    font-size: 12px;\n    color: var(--chat-muted);\n    background: var(--chat-event-bg);\n    padding: 2px 10px;\n    border-radius: 10px;\n}\n.ticket-chat__event[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 8px 0;\n}\n.ticket-chat__event span[data-v-395ac1a0] {\n    font-style: italic;\n}\n.ticket-chat__notice[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    margin-top: 40px;\n    color: var(--chat-muted);\n    text-align: center;\n}\n.ticket-chat__skeleton-bubble[data-v-395ac1a0] {\n    height: 44px;\n    width: 55%;\n    margin: 10px 0;\n    border-radius: 14px;\n    background: var(--skeleton);\n}\n.ticket-chat__skeleton-bubble--mine[data-v-395ac1a0] {\n    margin-left: auto;\n    width: 40%;\n}\n\n/* --- Wiadomości --- */\n.chat-row[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    gap: 8px;\n    margin-top: 2px;\n}\n.chat-row--start[data-v-395ac1a0] {\n    margin-top: 10px;\n}\n.chat-row--mine[data-v-395ac1a0] {\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.chat-avatar[data-v-395ac1a0] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 30px;\n            flex: 0 0 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: var(--chat-avatar-bg);\n    color: var(--chat-avatar-fg);\n    font-size: 12px;\n    font-weight: 600;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-item-align: start;\n        align-self: flex-start;\n    margin-top: 18px;\n}\n.chat-avatar--hidden[data-v-395ac1a0] {\n    visibility: hidden;\n    height: 0;\n    margin-top: 0;\n}\n.chat-column[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    max-width: 78%;\n    min-width: 0;\n}\n.chat-row--mine .chat-column[data-v-395ac1a0] {\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n}\n.chat-author[data-v-395ac1a0] {\n    font-size: 12px;\n    color: var(--chat-muted);\n    margin: 0 0 2px 4px;\n}\n.chat-bubble[data-v-395ac1a0] {\n    padding: 7px 12px;\n    border-radius: 6px 16px 16px 6px;\n    background: var(--chat-bubble-bg);\n    color: var(--chat-bubble-fg);\n    font-size: 14px;\n    line-height: 1.4;\n}\n.chat-bubble--start[data-v-395ac1a0] { border-top-left-radius: 16px;\n}\n.chat-bubble--end[data-v-395ac1a0] { border-bottom-left-radius: 16px;\n}\n.chat-bubble--mine[data-v-395ac1a0] {\n    border-radius: 16px 6px 6px 16px;\n    background: var(--chat-bubble-mine-bg);\n    color: var(--chat-bubble-mine-fg);\n}\n.chat-bubble--mine.chat-bubble--start[data-v-395ac1a0] { border-top-right-radius: 16px;\n}\n.chat-bubble--mine.chat-bubble--end[data-v-395ac1a0] { border-bottom-right-radius: 16px;\n}\n.chat-bubble--pending[data-v-395ac1a0] {\n    opacity: 0.6;\n}\n.chat-bubble--failed[data-v-395ac1a0] {\n    outline: 2px solid var(--danger);\n}\n.chat-bubble__text[data-v-395ac1a0] {\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n}\n.chat-bubble__images[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 4px;\n    margin: 4px -6px -2px;\n}\n.chat-bubble__text + .chat-bubble__images[data-v-395ac1a0] {\n    margin-top: 8px;\n}\n.chat-time[data-v-395ac1a0] {\n    font-size: 11px;\n    color: var(--chat-muted);\n    margin: 2px 4px 0;\n}\n.chat-time--failed[data-v-395ac1a0] {\n    color: var(--danger);\n}\n.chat-retry[data-v-395ac1a0] {\n    border: none;\n    background: transparent;\n    color: var(--accent);\n    text-decoration: underline;\n    padding: 0 0 0 4px;\n    font-size: 11px;\n    cursor: pointer;\n}\n\n/* --- Dół panelu --- */\n.ticket-chat__banner[data-v-395ac1a0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 8px;\n    padding: 10px 14px;\n    background: var(--status-warning-tint);\n    border-top: 1px solid var(--messages-panel-border);\n    font-size: 14px;\n    font-weight: 600;\n}\n.ticket-chat__closed[data-v-395ac1a0] {\n    padding: 12px;\n    text-align: center;\n    font-size: 13px;\n    color: var(--chat-muted);\n    border-top: 1px solid var(--messages-panel-border);\n}\n.ticket-chat__drop[data-v-395ac1a0] {\n    position: absolute;\n    inset: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    background: var(--chat-drop-bg);\n    border: 2px dashed var(--accent);\n    border-radius: 5px;\n    color: var(--text-strong);\n    font-weight: 600;\n    pointer-events: none;\n}\n\n/* --- Podgląd zdjęć --- */\n.chat-viewer[data-v-395ac1a0] {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    margin-top: 5px;\n}\n.chat-viewer__img[data-v-395ac1a0] {\n    max-width: 70vw;\n    max-height: 70vh;\n}\n.chat-viewer__placeholder[data-v-395ac1a0] {\n    width: 40vw;\n    height: 50vh;\n    background: var(--skeleton);\n}\n.chat-viewer__nav[data-v-395ac1a0] {\n    border: none;\n    background: var(--surface-hover);\n    color: var(--text);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    font-size: 22px;\n    line-height: 1;\n    cursor: pointer;\n}\n.chat-viewer__counter[data-v-395ac1a0] {\n    position: absolute;\n    bottom: -24px;\n    left: 0;\n    right: 0;\n    text-align: center;\n    font-size: 12px;\n    color: var(--chat-muted);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2297), __esModule: true };

/***/ }),

/***/ 2297:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2298);
module.exports = __webpack_require__(105).Object.values;


/***/ }),

/***/ 2298:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(183);
var $values = __webpack_require__(2299)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 2299:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var toIObject = __webpack_require__(299);
var isEnum = __webpack_require__(1555).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 2300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatImage_vue__ = __webpack_require__(1888);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7947a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatImage_vue__ = __webpack_require__(2303);
function injectStyle (ssrContext) {
  __webpack_require__(2301)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39e7947a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e7947a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2301:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2302);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("4d0cc348", content, true, {});

/***/ }),

/***/ 2302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".chat-image[data-v-39e7947a]{width:120px;height:90px;padding:0;border:none;border-radius:8px;overflow:hidden;cursor:-webkit-zoom-in;cursor:zoom-in;background:var(--chat-image-placeholder)}.chat-image img[data-v-39e7947a]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.chat-image--failed[data-v-39e7947a]{cursor:default}.chat-image__failed[data-v-39e7947a]{color:var(--chat-muted);font-weight:700}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/Tickets/ChatImage.vue"],"names":[],"mappings":"AACA,6BACI,YAAa,AACb,YAAa,AACb,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,wCAA0C,CAC7C,AACD,iCACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,aAAe,CAClB,AACD,qCACI,cAAgB,CACnB,AACD,qCACI,wBAAyB,AACzB,eAAkB,CACrB","file":"ChatImage.vue","sourcesContent":["\n.chat-image[data-v-39e7947a] {\n    width: 120px;\n    height: 90px;\n    padding: 0;\n    border: none;\n    border-radius: 8px;\n    overflow: hidden;\n    cursor: -webkit-zoom-in;\n    cursor: zoom-in;\n    background: var(--chat-image-placeholder);\n}\n.chat-image img[data-v-39e7947a] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    display: block;\n}\n.chat-image--failed[data-v-39e7947a] {\n    cursor: default;\n}\n.chat-image__failed[data-v-39e7947a] {\n    color: var(--chat-muted);\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"chat-image",class:{ 'chat-image--failed': _vm.failed },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('open')}}},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):(_vm.failed)?_c('span',{staticClass:"chat-image__failed"},[_vm._v("!")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatComposer_vue__ = __webpack_require__(1889);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e3e12a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatComposer_vue__ = __webpack_require__(2307);
function injectStyle (ssrContext) {
  __webpack_require__(2305)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08e3e12a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatComposer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e3e12a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatComposer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2305:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2306);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("663b510e", content, true, {});

/***/ }),

/***/ 2306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".chat-composer[data-v-08e3e12a]{border-top:1px solid var(--messages-panel-border);padding:8px 10px;background:var(--chat-composer-bg)}.chat-composer__row[data-v-08e3e12a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;gap:6px}.chat-composer__input[data-v-08e3e12a]{-webkit-box-flex:1;-ms-flex:1;flex:1;resize:none;min-height:38px;max-height:140px;padding:8px 12px;border:1px solid var(--input-border);border-radius:18px;background:var(--input-bg);color:var(--text);font-size:14px;line-height:20px;outline:none}.chat-composer__input[data-v-08e3e12a]:focus{border-color:var(--accent)}.chat-composer__file[data-v-08e3e12a]{display:none}.chat-composer__icon[data-v-08e3e12a],.chat-composer__send[data-v-08e3e12a]{-webkit-box-flex:0;-ms-flex:0 0 38px;flex:0 0 38px;height:38px;border:none;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}.chat-composer__icon[data-v-08e3e12a]{background:transparent;color:var(--text-muted)}.chat-composer__icon[data-v-08e3e12a]:hover{background:var(--surface-hover);color:var(--text)}.chat-composer__send[data-v-08e3e12a]{background:var(--chat-bubble-mine-bg);color:var(--chat-bubble-mine-fg)}.chat-composer__send[data-v-08e3e12a]:disabled{opacity:.4;cursor:default}.chat-composer__attachments[data-v-08e3e12a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;margin-bottom:8px}.chat-composer__attachment[data-v-08e3e12a]{position:relative;width:64px;height:64px}.chat-composer__attachment img[data-v-08e3e12a]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:6px}.chat-composer__remove[data-v-08e3e12a]{position:absolute;top:-6px;right:-6px;width:20px;height:20px;border:none;border-radius:50%;background:var(--danger);color:#fff;line-height:18px;font-size:14px;padding:0;cursor:pointer}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/Tickets/ChatComposer.vue"],"names":[],"mappings":"AACA,gCACI,kDAAmD,AACnD,iBAAkB,AAClB,kCAAoC,CACvC,AACD,qCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,OAAS,CACZ,AACD,uCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,gBAAiB,AACjB,iBAAkB,AAClB,iBAAkB,AAClB,qCAAsC,AACtC,mBAAoB,AACpB,2BAA4B,AAC5B,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,YAAc,CACjB,AACD,6CACI,0BAA4B,CAC/B,AACD,sCACI,YAAc,CACjB,AACD,4EAEI,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,cAAgB,CACnB,AACD,sCACI,uBAAwB,AACxB,uBAAyB,CAC5B,AACD,4CACI,gCAAiC,AACjC,iBAAmB,CACtB,AACD,sCACI,sCAAuC,AACvC,gCAAkC,CACrC,AACD,+CACI,WAAa,AACb,cAAgB,CACnB,AACD,6CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,QAAS,AACT,iBAAmB,CACtB,AACD,4CACI,kBAAmB,AACnB,WAAY,AACZ,WAAa,CAChB,AACD,gDACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,iBAAmB,CACtB,AACD,wCACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,UAAW,AACX,cAAgB,CACnB","file":"ChatComposer.vue","sourcesContent":["\n.chat-composer[data-v-08e3e12a] {\n    border-top: 1px solid var(--messages-panel-border);\n    padding: 8px 10px;\n    background: var(--chat-composer-bg);\n}\n.chat-composer__row[data-v-08e3e12a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    gap: 6px;\n}\n.chat-composer__input[data-v-08e3e12a] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    resize: none;\n    min-height: 38px;\n    max-height: 140px;\n    padding: 8px 12px;\n    border: 1px solid var(--input-border);\n    border-radius: 18px;\n    background: var(--input-bg);\n    color: var(--text);\n    font-size: 14px;\n    line-height: 20px;\n    outline: none;\n}\n.chat-composer__input[data-v-08e3e12a]:focus {\n    border-color: var(--accent);\n}\n.chat-composer__file[data-v-08e3e12a] {\n    display: none;\n}\n.chat-composer__icon[data-v-08e3e12a],\n.chat-composer__send[data-v-08e3e12a] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 38px;\n            flex: 0 0 38px;\n    height: 38px;\n    border: none;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    cursor: pointer;\n}\n.chat-composer__icon[data-v-08e3e12a] {\n    background: transparent;\n    color: var(--text-muted);\n}\n.chat-composer__icon[data-v-08e3e12a]:hover {\n    background: var(--surface-hover);\n    color: var(--text);\n}\n.chat-composer__send[data-v-08e3e12a] {\n    background: var(--chat-bubble-mine-bg);\n    color: var(--chat-bubble-mine-fg);\n}\n.chat-composer__send[data-v-08e3e12a]:disabled {\n    opacity: 0.4;\n    cursor: default;\n}\n.chat-composer__attachments[data-v-08e3e12a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n.chat-composer__attachment[data-v-08e3e12a] {\n    position: relative;\n    width: 64px;\n    height: 64px;\n}\n.chat-composer__attachment img[data-v-08e3e12a] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 6px;\n}\n.chat-composer__remove[data-v-08e3e12a] {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    width: 20px;\n    height: 20px;\n    border: none;\n    border-radius: 50%;\n    background: var(--danger);\n    color: #fff;\n    line-height: 18px;\n    font-size: 14px;\n    padding: 0;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-composer"},[(_vm.attachments.length > 0)?_c('div',{staticClass:"chat-composer__attachments"},_vm._l((_vm.attachments),function(item,index){return _c('div',{key:item.url,staticClass:"chat-composer__attachment"},[_c('img',{attrs:{"src":item.url,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"chat-composer__remove",attrs:{"type":"button","title":_vm.$t('Remove')},on:{"click":function($event){return _vm.removeAttachment(index)}}},[_vm._v("×")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-composer__row"},[_c('button',{staticClass:"chat-composer__icon",attrs:{"type":"button","title":_vm.$t('AttachPhotos')},on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"}})])]),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"chat-composer__file",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],ref:"input",staticClass:"chat-composer__input",attrs:{"rows":"1","placeholder":_vm.$t('WriteMessage')},domProps:{"value":(_vm.text)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.text=$event.target.value},_vm.autoGrow],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},"paste":_vm.onPaste}}),_vm._v(" "),_c('button',{staticClass:"chat-composer__send",attrs:{"type":"button","disabled":!_vm.canSend,"title":_vm.$t('Send')},on:{"click":_vm.submit}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M22 2L11 13"}}),_c('path',{attrs:{"d":"M22 2l-7 20-4-9-9-4 20-7z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-chat",on:{"dragover":function($event){$event.preventDefault();return _vm.onDragOver.apply(null, arguments)},"dragleave":_vm.onDragLeave,"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[_c('header',{staticClass:"ticket-chat__header"},[(_vm.showBack)?_c('button',{staticClass:"ticket-chat__back",attrs:{"type":"button","title":_vm.$t('Back')},on:{"click":function($event){return _vm.$emit('back')}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15 18l-6-6 6-6"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ticket-chat__title"},[_c('div',{staticClass:"ticket-chat__subject",attrs:{"title":_vm.subject}},[_vm._v(_vm._s(_vm.subject))]),_vm._v(" "),_c('div',{staticClass:"ticket-chat__meta"},[_c('span',{staticClass:"ticket-chat__status",class:'ticket-chat__status--' + _vm.status},[_vm._v(_vm._s(_vm.statusLabel))]),_vm._v(" "),(_vm.assigneeName)?_c('span',[_vm._v(_vm._s(_vm.assigneeName))]):_vm._e(),_vm._v(" "),(_vm.createDate)?_c('span',{attrs:{"title":_vm.formatFull(_vm.createDate)}},[_vm._v(_vm._s(_vm.formatDay(_vm.createDate)))]):_vm._e()])]),_vm._v(" "),(_vm.canManage && _vm.status != _vm.TicketStatus.WaitingForApprove && _vm.status != _vm.TicketStatus.Closed)?_c('div',{staticClass:"ticket-chat__actions"},[(!_vm.confirmingClose)?_c('button',{staticClass:"ticket-chat__action",attrs:{"type":"button"},on:{"click":function($event){_vm.confirmingClose = true}}},[_vm._v(_vm._s(_vm.$t('CloseTicketButton')))]):[_c('span',{staticClass:"ticket-chat__confirm"},[_vm._v(_vm._s(_vm.$t('CloseTicketConfirm')))]),_vm._v(" "),_c('button',{staticClass:"ticket-chat__action ticket-chat__action--danger",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.closeTicket}},[_vm._v(_vm._s(_vm.$t('Yes')))]),_vm._v(" "),_c('button',{staticClass:"ticket-chat__action",attrs:{"type":"button"},on:{"click":function($event){_vm.confirmingClose = false}}},[_vm._v(_vm._s(_vm.$t('No')))])]],2):_vm._e()]),_vm._v(" "),_c('div',{ref:"list",staticClass:"ticket-chat__list"},[(_vm.loading)?_c('div',{staticClass:"ticket-chat__skeleton"},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"ticket-chat__skeleton-bubble",class:{ 'ticket-chat__skeleton-bubble--mine': n % 2 == 0 }})}),0):(_vm.error)?_c('div',{staticClass:"ticket-chat__notice"},[_c('div',[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('button',{staticClass:"ticket-chat__action",attrs:{"type":"button"},on:{"click":function($event){return _vm.load()}}},[_vm._v(_vm._s(_vm.$t('TryAgain')))])]):[_vm._l((_vm.timeline),function(item){return [(item.type == 'day')?_c('div',{key:item.key,staticClass:"ticket-chat__day"},[_c('span',[_vm._v(_vm._s(_vm.dayLabel(item.date)))])]):(item.type == 'event')?_c('div',{key:item.key,staticClass:"ticket-chat__event"},[_c('span',{attrs:{"title":_vm.formatFull(item.message.sentDate)}},[_vm._v(_vm._s(_vm.eventText(item.message))+" · "+_vm._s(_vm.formatTime(item.message.sentDate)))])]):_c('div',{key:item.key,staticClass:"chat-row",class:{ 'chat-row--mine': item.mine, 'chat-row--start': item.startsGroup }},[(!item.mine)?_c('div',{staticClass:"chat-avatar",class:{ 'chat-avatar--hidden': !item.startsGroup },attrs:{"title":item.message.creatorName}},[_vm._v("\n                        "+_vm._s(_vm.initials(item.message.creatorName))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-column"},[(item.startsGroup && !item.mine)?_c('div',{staticClass:"chat-author"},[_vm._v(_vm._s(item.message.creatorName))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-bubble",class:{
                                 'chat-bubble--mine': item.mine,
                                 'chat-bubble--start': item.startsGroup,
                                 'chat-bubble--end': item.endsGroup,
                                 'chat-bubble--pending': item.message.state == 'sending',
                                 'chat-bubble--failed': item.message.state == 'failed'
                             },attrs:{"title":_vm.formatFull(item.message.sentDate)}},[(item.message.content)?_c('div',{staticClass:"chat-bubble__text"},[_vm._v(_vm._s(item.message.content))]):_vm._e(),_vm._v(" "),(_vm.hasImages(item.message))?_c('div',{staticClass:"chat-bubble__images"},[_vm._l((item.message.resources),function(id){return _c('chat-image',{key:id,attrs:{"src":_vm.imageUrl(id),"failed":_vm.imageFailed(id)},on:{"visible":function($event){return _vm.loadImage(id)},"open":function($event){return _vm.openViewer(id)}}})}),_vm._v(" "),_vm._l((item.message.localPhotos),function(url){return _c('chat-image',{key:url,attrs:{"src":url},on:{"open":function($event){return _vm.openLocal(url)}}})})],2):_vm._e()]),_vm._v(" "),(item.message.state == 'failed')?_c('div',{staticClass:"chat-time chat-time--failed"},[_vm._v("\n                            "+_vm._s(_vm.$t(item.message.errorKey || 'MessageNotSent'))+"\n                            "),_c('button',{staticClass:"chat-retry",attrs:{"type":"button"},on:{"click":function($event){return _vm.retry(item.message)}}},[_vm._v(_vm._s(_vm.$t('TryAgain')))])]):(item.message.state == 'sending')?_c('div',{staticClass:"chat-time"},[_vm._v(_vm._s(_vm.$t('Sending')))]):(item.endsGroup)?_c('div',{staticClass:"chat-time"},[_vm._v(_vm._s(_vm.formatTime(item.message.sentDate)))]):_vm._e()])])]}),_vm._v(" "),(_vm.timeline.length == 0)?_c('div',{staticClass:"ticket-chat__notice"},[_vm._v(_vm._s(_vm.$t('NoMessages')))]):_vm._e()]],2),_vm._v(" "),(_vm.status == _vm.TicketStatus.WaitingForApprove && _vm.canManage)?_c('div',{staticClass:"ticket-chat__banner"},[_c('span',[_vm._v(_vm._s(_vm.$t('TicketCloseRequested')))]),_vm._v(" "),_c('div',{staticClass:"ticket-chat__banner-actions"},[_c('button',{staticClass:"ticket-chat__action ticket-chat__action--primary",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.closeTicket}},[_vm._v(_vm._s(_vm.$t('Accept')))]),_vm._v(" "),_c('button',{staticClass:"ticket-chat__action",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.denyClose}},[_vm._v(_vm._s(_vm.$t('Deny')))])])]):_vm._e(),_vm._v(" "),(_vm.status != _vm.TicketStatus.Closed)?_c('chat-composer',{ref:"composer",on:{"send":_vm.send}}):_c('div',{staticClass:"ticket-chat__closed"},[_vm._v(_vm._s(_vm.$t('TicketClosedInfo')))]),_vm._v(" "),(_vm.dragging)?_c('div',{staticClass:"ticket-chat__drop"},[_vm._v(_vm._s(_vm.$t('DropPhotosHere')))]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.viewer != null},on:{"close":function($event){_vm.viewer = null}}},[(_vm.viewer != null)?_c('div',{staticClass:"chat-viewer"},[(_vm.viewer.items.length > 1)?_c('button',{staticClass:"chat-viewer__nav",attrs:{"type":"button"},on:{"click":function($event){return _vm.moveViewer(-1)}}},[_vm._v("‹")]):_vm._e(),_vm._v(" "),(_vm.viewerUrl)?_c('img',{staticClass:"chat-viewer__img",attrs:{"src":_vm.viewerUrl,"alt":""}}):_c('div',{staticClass:"chat-viewer__placeholder"}),_vm._v(" "),(_vm.viewer.items.length > 1)?_c('button',{staticClass:"chat-viewer__nav",attrs:{"type":"button"},on:{"click":function($event){return _vm.moveViewer(1)}}},[_vm._v("›")]):_vm._e(),_vm._v(" "),(_vm.viewer.items.length > 1)?_c('div',{staticClass:"chat-viewer__counter"},[_vm._v(_vm._s(_vm.viewer.index + 1)+" / "+_vm._s(_vm.viewer.items.length))]):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":(_vm.activeModal == 'ADD_TICKET'),"title":_vm.$t('AddTicket')},on:{"close":_vm.closeModal}},[_c('ticket-modal',{attrs:{"system-id":_vm.systemId},on:{"saved":_vm.closeModal}})],1),_vm._v(" "),_c('div',{staticClass:"max-grid tickets-layout",class:{ 'tickets-layout--mobile': _vm.isMobile }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.selectedTicket == null),expression:"!isMobile || selectedTicket == null"}],staticClass:"tickets-layout__grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":false,"dataBound":_vm.dataBound,"dataSource":_vm.tickets,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"sortSettings":_vm.sortSettings,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true,"rowDataBound":_vm.rowDataBound,"rowSelected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"field":"id","isPrimaryKey":true,"visible":false}}),_vm._v(" "),_c('e-column',{attrs:{"field":"lastMessageDate","headerText":_vm.$t('LastMessage'),"width":"170","textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"subject","headerText":_vm.$t('Subject'),"template":_vm.TextTemplate,"width":"320","minWidth":"200","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"statusLabel","headerText":_vm.$t('Status'),"width":"150","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"assigneeName","headerText":_vm.$t('AssigneeName'),"width":"200","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"lastMessageFrom","headerText":_vm.$t('LastMessageFrom'),"width":"200","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"width":"170","textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions}})],1)],1)],1),_vm._v(" "),(!_vm.isMobile || _vm.selectedTicket != null)?_c('div',{staticClass:"messages-area tickets-layout__chat"},[(_vm.selectedTicket != null)?_c('ticket-chat',{attrs:{"ticket":_vm.selectedTicket,"show-back":_vm.isMobile},on:{"read":_vm.markRead,"changed":_vm.getData,"back":_vm.clearSelection}}):_c('div',{staticClass:"messages-area__empty"},[_vm._v(_vm._s(_vm.$t('SelectTicket')))])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.d70478c065e3f01cfd92.js